(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[213],{

/***/ 8213:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Xq": function() { return /* reexport */ LandingFeatures; },
  "Cf": function() { return /* reexport */ LandingFooter; },
  "Sx": function() { return /* reexport */ LandingHeader; },
  "O3": function() { return /* reexport */ LandingIntegrations; },
  "a2": function() { return /* reexport */ LandingLayout; },
  "dD": function() { return /* reexport */ LandingLogoCloud; },
  "ZC": function() { return /* reexport */ LandingNotImplementedYet; },
  "_z": function() { return /* reexport */ LandingProductions; },
  "OU": function() { return /* reexport */ LandingSignup; },
  "tA": function() { return /* reexport */ LandingSplash; }
});

// UNUSED EXPORTS: HeaderNav, LandingBackground, LandingFeatureOverview, LandingScreenshot, MenuItem, Stars, StyledFeatureCloud, StyledHeaderNav, StyledLandingFeature, StyledLandingFooter, StyledLandingHeader, StyledLandingLayout, StyledLandingScreenshotFigure, StyledLandingSection, StyledLandingSplash, StyledLogoCloud, StyledMediaCard, StyledMenuItem, StyledNewsletter, StyledSubMenuItem, StyledSubMenuItems, SubMenuItem, SubMenuItems, Underline, mobileMenuVariants, splashParentVariants, splashVariants, spring

// EXTERNAL MODULE: ../../node_modules/@linaria/react/esm/styled.js + 3 modules
var styled = __webpack_require__(408);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(5235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(2269);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
;// CONCATENATED MODULE: ../../packages/styleguide/src/components/IconButton.tsx


const _excluded = ["children", "alt", "label", "onClick", "disabled"],
      _excluded2 = (/* unused pure expression or super */ null && (["on", "off", "onLabel", "offLabel", "label", "alt", "active", "onClick", "disabled"]));

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0,defineProperty/* default */.Z)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}






const StyledIconButton = /*#__PURE__*/(0,styled/* default */.Z)("button")({
  name: "StyledIconButton",
  class: "sqtdz8h",
  vars: {
    "sqtdz8h-0": [props => props.rotate ? "rotate(".concat(props.rotate, ")") : 'none'],
    "sqtdz8h-1": [props => props.rotate ? "scale(0.8) rotate(".concat(props.rotate, ")") : 'scale(0.8) ']
  }
});
const DEFAULT_ICONBUTTON_LABEL = 'Unlabeled IconButton';
const IconButton = /*#__PURE__*/(0,react.forwardRef)(function IconButtonInner(_ref, ref) {
  let {
    children = /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
    alt,
    label,
    onClick = () => {},
    disabled = false
  } = _ref,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  const actualLabel = alt || label || DEFAULT_ICONBUTTON_LABEL;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledIconButton, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    role: "button",
    "aria-label": actualLabel,
    tabIndex: 0,
    title: actualLabel,
    disabled: disabled,
    onClick: disabled === true ? () => {} : onClick,
    children: [children, /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      className: "visually-hidden",
      children: label || alt || DEFAULT_ICONBUTTON_LABEL
    })]
  }));
});
const IconToggleButton = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function IconButtonInner(_ref2, ref) {
  let {
    on,
    off,
    onLabel = '',
    offLabel = '',
    label: labelInput,
    alt,
    active = false,
    onClick = () => {},
    disabled = false
  } = _ref2,
      props = _objectWithoutProperties(_ref2, _excluded2);

  let label = alt || labelInput || DEFAULT_ICONBUTTON_LABEL;

  if (onLabel && offLabel) {
    label = active == true ? onLabel : offLabel;
  }

  return /*#__PURE__*/_jsxs(StyledIconButton, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    role: "button",
    "aria-label": label,
    tabIndex: 0,
    title: label,
    disabled: disabled,
    onClick: disabled === true ? () => {} : onClick,
    children: [active === true && on, active === false && off, /*#__PURE__*/_jsx("span", {
      className: "visually-hidden",
      children: label || DEFAULT_ICONBUTTON_LABEL
    })]
  }));
})));

__webpack_require__(329);
;// CONCATENATED MODULE: ../../packages/styleguide/src/icons/AbstractIcon.tsx


const AbstractIcon_excluded = ["children", "label", "enableFilters"];

function AbstractIcon_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function AbstractIcon_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      AbstractIcon_ownKeys(Object(source), true).forEach(function (key) {
        (0,defineProperty/* default */.Z)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      AbstractIcon_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}


/**
 * Icon Template
 */




const IconTemplate = (name, svg) => "\nimport {IconProps, AbstractIcon} from './AbstractIcon'\n\nexport const ICON_NAME = (props:IconProps) => {\n\treturn (\n\t\t<AbstractIcon {...props}>\n\t\t\t".concat(svg, "\n\t\t</AbstractIcon>\n\t)\n}\n");
const StyledIcon = /*#__PURE__*/(0,styled/* default */.Z)("svg")({
  name: "StyledIcon",
  class: "s11apfzl",
  vars: {
    "s11apfzl-0": [props => props.size || props.width || '3rem'],
    "s11apfzl-2": [props => props.size || props.height || '3rem'],
    "s11apfzl-3": [props => props.rotate ? "rotate(".concat(props.rotate, ")") : 'none'],
    "s11apfzl-4": [props => props.color || 'var(--clr-icon, #1a1a1a)'],
    "s11apfzl-5": [props => props.colorAlt || 'var(--clr-icon-alt, #f4f5f4)'],
    "s11apfzl-7": [props => props.strokeWidth || '1.6'],
    "s11apfzl-8": [({
      hasShadow = false,
      hasGlow = false
    }) => hasShadow || hasGlow ? "".concat(hasShadow ? 'url(#shadow)' : '', " ").concat(hasGlow ? 'url(#glow)' : '') : 'none']
  }
});
const AbstractIcon = _ref => {
  let {
    children,
    label = '',
    enableFilters = true
  } = _ref,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, AbstractIcon_excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(StyledIcon, AbstractIcon_objectSpread(AbstractIcon_objectSpread({
      fill: "transparent"
    }, props), {}, {
      viewBox: props.viewBox || '0 0 24 24',
      ariaHidden: props.ariaHidden === false ? false : true,
      focusable: props.focusable || false,
      xmlns: "http://www.w3.org/2000/svg",
      className: props.className || '',
      children: [children, enableFilters == true ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("filter", {
          id: "shadow",
          colorInterpolationFilters: "linearRGB",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("feDropShadow", {
            dx: "0",
            dy: "0",
            stdDeviation: "2",
            floodColor: props.shadowColor || 'var(--clr-bg, #202224)',
            floodOpacity: "1"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("filter", {
          id: "glow",
          height: "300%",
          width: "300%",
          x: "-75%",
          y: "-75%",
          colorInterpolationFilters: "linearRGB",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("feMorphology", {
            id: "glowRadius",
            operator: "dilate",
            radius: "1",
            in: "SourceAlpha",
            result: "thicken"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("feGaussianBlur", {
            in: "thicken",
            stdDeviation: "1",
            result: "blurred"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("feFlood", {
            floodColor: props.glowColor || 'var(--clr-blue)',
            result: "glowColor"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("feComposite", {
            in: "glowColor",
            in2: "blurred",
            operator: "in",
            result: "softGlow_colored"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("feMorphology", {
            operator: "dilate",
            radius: "2",
            in: "SourceAlpha",
            result: "thicken2"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("feGaussianBlur", {
            in: "thicken2",
            stdDeviation: "3",
            result: "blurred2"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("feFlood", {
            floodColor: props.glowColor2 || '#5ed4ff',
            result: "glowColor2"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("feComposite", {
            in: "glowColor2",
            in2: "blurred2",
            operator: "in",
            result: "softGlow_colored2"
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("feMerge", {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("feMergeNode", {
              in: "softGlow_colored"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("feMergeNode", {
              in: "softGlow_colored2"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("feMergeNode", {
              in: "SourceGraphic"
            })]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("filter", {
          id: "glowXL",
          height: "300%",
          width: "300%",
          x: "-75%",
          y: "-75%",
          colorInterpolationFilters: "linearRGB",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("feMorphology", {
            id: "glowRadius",
            operator: "dilate",
            radius: "4",
            in: "SourceAlpha",
            result: "thicken"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("feGaussianBlur", {
            in: "thicken",
            stdDeviation: "5",
            result: "blurredXL"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("feFlood", {
            floodColor: props.glowColor || 'var(--clr-blue)',
            result: "glowColorXL"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("feComposite", {
            in: "glowColorXL",
            in2: "blurredXL",
            operator: "in",
            result: "softGlowXL_colored"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("feMorphology", {
            operator: "dilate",
            radius: "2",
            in: "SourceAlpha",
            result: "thickenXL2"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("feGaussianBlur", {
            in: "thickenXL2",
            stdDeviation: "3",
            result: "blurredXL2"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("feFlood", {
            floodColor: props.glowColor2 || '#5ed4ff',
            result: "glowColorXL2"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("feComposite", {
            in: "glowColorXL2",
            in2: "blurredXL2",
            operator: "in",
            result: "softGlowXL_colored2"
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("feMerge", {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("feMergeNode", {
              in: "softGlowXL_colored"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("feMergeNode", {
              in: "softGlowXL_colored2"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("feMergeNode", {
              in: "SourceGraphic"
            })]
          })]
        })]
      }) : null]
    })), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      className: "visually-hidden",
      children: label
    })]
  });
};

__webpack_require__(3981);
;// CONCATENATED MODULE: ../../packages/styleguide/src/components/social/TwitterIcon.tsx


function TwitterIcon_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function TwitterIcon_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      TwitterIcon_ownKeys(Object(source), true).forEach(function (key) {
        (0,defineProperty/* default */.Z)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      TwitterIcon_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}



const TwitterIcon = props => {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(AbstractIcon, TwitterIcon_objectSpread(TwitterIcon_objectSpread({}, props), {}, {
    "data-icon": "TwitterIcon",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M19.8106 8.29421L18.3422 7.66936L19.1108 5.99164L17.3206 6.58525C16.8735 6.17286 16.3158 5.89994 15.7158 5.79998C15.1158 5.70001 14.4998 5.77735 13.9431 6.0225C13.3865 6.26765 12.9135 6.66995 12.5822 7.18004C12.2509 7.69014 12.0757 8.28584 12.0781 8.89407V9.59077C9.6037 10.1031 7.44485 8.75347 5.43908 6.44465C5.08916 8.3192 5.43908 9.71783 6.48883 10.6405L4.18938 10.2906C4.27751 11.0308 4.62309 11.7165 5.16567 12.2276C5.70824 12.7388 6.41327 13.0429 7.15741 13.0868L5.236 13.7866C5.93584 15.1863 7.2074 15.4019 8.907 15.5362C7.51834 16.4818 5.869 16.9701 4.18938 16.9328C13.106 20.8974 18.3422 15.0738 18.3422 9.94069V9.36271L19.8106 8.29421Z",
      className: "filled"
    })
  }));
};
;// CONCATENATED MODULE: ../../packages/styleguide/src/components/social/YouTubeIcon.tsx


function YouTubeIcon_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function YouTubeIcon_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      YouTubeIcon_ownKeys(Object(source), true).forEach(function (key) {
        (0,defineProperty/* default */.Z)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      YouTubeIcon_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}



const YouTubeIcon = props => {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(AbstractIcon, YouTubeIcon_objectSpread(YouTubeIcon_objectSpread({}, props), {}, {
    "data-icon": "YouTubeIcon",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.72254 17.3911C10.2396 17.5711 13.7636 17.5711 17.2806 17.3911C17.91 17.3612 18.5075 17.1053 18.9634 16.6703C19.4193 16.2353 19.7029 15.6504 19.7623 15.0231C19.9359 13.0114 19.9359 10.9885 19.7623 8.97687C19.7036 8.34931 19.4201 7.76409 18.9641 7.32896C18.5081 6.89384 17.9102 6.63812 17.2806 6.60888C13.7636 6.42892 10.2396 6.42892 6.72254 6.60888C6.09279 6.63868 5.49489 6.8945 5.03849 7.32944C4.58209 7.76439 4.2978 8.34928 4.23773 8.97687C4.06408 10.9885 4.06408 13.0114 4.23773 15.0231C4.29652 15.6512 4.58042 16.2368 5.03708 16.672C5.49375 17.1072 6.09236 17.3626 6.72254 17.3911ZM10.4229 9.36206L14.6316 11.9953L10.4229 14.6253V9.36206Z",
      className: "filled"
    })
  }));
};
;// CONCATENATED MODULE: ../../packages/styleguide/src/components/social/TikTokIcon.tsx


function TikTokIcon_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function TikTokIcon_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      TikTokIcon_ownKeys(Object(source), true).forEach(function (key) {
        (0,defineProperty/* default */.Z)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      TikTokIcon_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}




const TikTokIcon = props => {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(AbstractIcon, TikTokIcon_objectSpread(TikTokIcon_objectSpread({}, props), {}, {
    "data-icon": "YouTubeIcon",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M17.5174 8.86143V10.5806C17.5174 10.5806 16.703 10.5487 16.0998 10.3953C15.2579 10.1807 14.7165 9.85172 14.7165 9.85172C14.7165 9.85172 14.343 9.61709 14.3128 9.60046V14.1328C14.3128 14.3851 14.2437 15.0156 14.033 15.5409C13.758 16.2287 13.3335 16.68 13.2555 16.7722C13.2555 16.7722 12.739 17.3823 11.8286 17.7931C11.008 18.1637 10.2873 18.1543 10.0716 18.1637C10.0716 18.1637 8.82597 18.213 7.70461 17.4845L7.69901 17.4804C7.58062 17.3658 7.46917 17.2447 7.36523 17.1179C7.00739 16.6816 6.78804 16.1657 6.73292 16.0185C6.73283 16.0178 6.73283 16.0172 6.73292 16.0166C6.64423 15.7608 6.45789 15.1464 6.48336 14.5514C6.5284 13.5016 6.89771 12.8572 6.99536 12.6958C7.25396 12.2556 7.59031 11.8617 7.98942 11.5317C8.34162 11.247 8.74083 11.0204 9.17067 10.8613C9.63534 10.6745 10.1329 10.5744 10.6367 10.5664V12.3067C10.6367 12.3067 9.71512 12.0144 8.97762 12.5319C8.46198 12.9148 8.18835 13.2884 8.10777 13.9556C8.10441 14.4465 8.23004 15.1413 8.91914 15.6047C8.99953 15.6556 9.07843 15.7009 9.15584 15.7404C9.27622 15.8969 9.42275 16.0332 9.5895 16.144C10.2627 16.5701 10.8267 16.5998 11.548 16.3231C12.0289 16.1381 12.391 15.7211 12.5588 15.259C12.6643 14.9705 12.6629 14.6801 12.6629 14.3798V5.83639H14.3416C14.411 6.23084 14.6029 6.79236 15.1104 7.34851C15.314 7.5585 15.5434 7.74415 15.7934 7.90144C15.8673 7.97786 16.245 8.35569 16.7298 8.58765C16.9805 8.70754 17.2448 8.79941 17.5174 8.86143V8.86143Z",
      className: "filled"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M9.17067 10.8613C8.74083 11.0204 8.34163 11.247 7.98943 11.5317C7.59018 11.8625 7.25392 12.2572 6.99564 12.6982C6.898 12.8591 6.52869 13.504 6.48364 14.5538C6.45818 15.1489 6.64452 15.7632 6.73321 16.019C6.73311 16.0196 6.73311 16.0203 6.73321 16.0209C6.78916 16.1668 7.00767 16.6827 7.36552 17.1203C7.46946 17.2472 7.5809 17.3682 7.6993 17.4829C7.31996 17.2314 6.98166 16.9274 6.69544 16.5808C6.34067 16.1483 6.12188 15.6377 6.06481 15.487C6.06474 15.4859 6.06474 15.4849 6.06481 15.4838V15.4819C5.97584 15.2264 5.78894 14.6117 5.81496 14.0159C5.86001 12.9661 6.22932 12.3217 6.32696 12.1603C6.58517 11.7192 6.92144 11.3245 7.32075 10.9938C7.67288 10.709 8.0721 10.4824 8.50199 10.3234C8.77014 10.2168 9.04948 10.1381 9.33518 10.0888C9.76576 10.0168 10.2055 10.0105 10.6381 10.0703V10.5664C10.1338 10.5743 9.63578 10.6744 9.17067 10.8613Z",
      className: "filled"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M14.343 5.8364H12.6643V14.3801C12.6643 14.6804 12.6643 14.97 12.5602 15.2593C12.3907 15.7211 12.03 16.1381 11.5494 16.3231C10.8278 16.6009 10.2638 16.5701 9.59088 16.144C9.42384 16.0337 9.27694 15.8978 9.1561 15.7417C9.72937 16.0348 10.2425 16.0297 10.8782 15.7852C11.3585 15.6002 11.7197 15.1832 11.8887 14.7211C11.9945 14.4326 11.9931 14.1422 11.9931 13.8421V5.29688H14.3111C14.3111 5.29688 14.2851 5.50925 14.343 5.8364ZM17.5174 8.38601V8.86144C17.2453 8.79932 16.9815 8.70746 16.7312 8.58766C16.2463 8.35571 15.8686 7.97788 15.7948 7.90145C15.8805 7.95539 15.9694 8.00445 16.0611 8.0484C16.6506 8.3305 17.2312 8.4147 17.5174 8.38601Z",
      className: "filled"
    })]
  }));
};
;// CONCATENATED MODULE: ../../packages/styleguide/src/components/social/LinkedInIcon.tsx


function LinkedInIcon_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function LinkedInIcon_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      LinkedInIcon_ownKeys(Object(source), true).forEach(function (key) {
        (0,defineProperty/* default */.Z)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      LinkedInIcon_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}



const LinkedInIcon = props => {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(AbstractIcon, LinkedInIcon_objectSpread(LinkedInIcon_objectSpread({}, props), {}, {
    "data-icon": "LinkedInIcon",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.66442 8.59154C6.33773 8.59486 6.01741 8.501 5.7442 8.32186C5.47098 8.14272 5.2572 7.8864 5.13 7.58547C5.0028 7.28455 4.96795 6.9526 5.02984 6.63181C5.09174 6.31103 5.24759 6.01588 5.47761 5.78388C5.70764 5.55189 6.00146 5.39351 6.32171 5.32888C6.64196 5.26425 6.97419 5.29629 7.27619 5.42091C7.57819 5.54554 7.83632 5.75714 8.01778 6.02882C8.19924 6.30049 8.29584 6.61998 8.29531 6.94668C8.29679 7.38097 8.1259 7.79809 7.82013 8.10648C7.51435 8.41487 7.0987 8.58932 6.66442 8.59154ZM8.29529 10.2392H5.03627V18.7037H8.29529V10.2392ZM15.4027 13.4074C15.1849 13.187 14.8886 13.062 14.5787 13.0598C14.2686 13.062 13.972 13.1869 13.7538 13.4072C13.5355 13.6276 13.4134 13.9254 13.4142 14.2355V18.7037H10.1552V10.2392H13.1712V11.7724C13.847 10.2392 15.6008 10.2392 15.6008 10.2392C19.017 10.2392 19.0037 13.3747 18.9997 14.3301C18.9996 14.3604 18.9995 14.3885 18.9995 14.4142V18.7037H15.7405V14.2355C15.742 13.9256 15.6205 13.6278 15.4027 13.4074Z",
      className: "filled"
    })
  }));
};
;// CONCATENATED MODULE: ../../packages/styleguide/src/components/social/GithubIcon.tsx


function GithubIcon_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function GithubIcon_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      GithubIcon_ownKeys(Object(source), true).forEach(function (key) {
        (0,defineProperty/* default */.Z)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      GithubIcon_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}




const GithubIcon = props => {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(AbstractIcon, GithubIcon_objectSpread(GithubIcon_objectSpread({}, props), {}, {
    "data-icon": "GithubIcon",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 5.17665C10.3379 5.1761 8.72991 5.76717 7.46386 6.84403C6.19782 7.9209 5.35642 9.41325 5.09029 11.0539C4.82417 12.6945 5.15071 14.3763 6.01145 15.7982C6.87219 17.22 8.21092 18.2891 9.78796 18.8139C10.1356 18.8788 10.2654 18.6621 10.2654 18.4779C10.2654 18.2936 10.2596 17.7595 10.2561 17.1743C8.3094 17.5984 7.8992 16.3493 7.8992 16.3493C7.58055 15.5381 7.12169 15.3249 7.12169 15.3249C6.4867 14.8904 7.17035 14.8997 7.17035 14.8997C7.87255 14.9495 8.24219 15.6204 8.24219 15.6204C8.86675 16.6911 9.8795 16.3817 10.2793 16.1998C10.3418 15.7479 10.5226 15.4397 10.7231 15.2647C9.16919 15.0874 7.53536 14.4872 7.53536 11.8058C7.52494 11.1106 7.78311 10.4382 8.2561 9.92866C8.18309 9.75137 7.94324 9.0399 8.3233 8.07467C8.3233 8.07467 8.91079 7.88695 10.248 8.79309C11.3951 8.47791 12.606 8.47791 13.7532 8.79309C15.0881 7.88695 15.6755 8.07467 15.6755 8.07467C16.0556 9.03875 15.8169 9.75022 15.7439 9.92866C16.2165 10.4384 16.4742 11.1108 16.4635 11.8058C16.4635 14.4941 14.8273 15.0862 13.2688 15.2589C13.5203 15.4756 13.7439 15.902 13.7439 16.5544C13.7439 17.4906 13.7358 18.245 13.7358 18.4756C13.7358 18.661 13.8609 18.88 14.2155 18.8104C15.792 18.2849 17.13 17.2154 17.99 15.7935C18.85 14.3716 19.1759 12.69 18.9094 11.0498C18.6429 9.40951 17.8014 7.91762 16.5354 6.84112C15.2695 5.76462 13.6618 5.17378 12 5.17433V5.17665Z",
      className: "filled"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M7.6524 15.223C7.63734 15.2589 7.58288 15.2682 7.53653 15.245C7.49018 15.2218 7.45657 15.1743 7.47395 15.1395C7.49133 15.1048 7.54348 15.0943 7.58983 15.1175C7.63618 15.1407 7.66862 15.1882 7.65124 15.223H7.6524Z",
      className: "filled"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M7.93627 15.5393C7.90267 15.5706 7.83778 15.5567 7.79374 15.5069C7.77244 15.4899 7.75841 15.4655 7.75454 15.4386C7.75066 15.4117 7.75722 15.3843 7.77289 15.362C7.80765 15.3307 7.87022 15.3458 7.91657 15.3945C7.96292 15.4431 7.97103 15.5103 7.93627 15.5393Z",
      className: "filled"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M8.21208 15.9425C8.1692 15.9727 8.0962 15.9425 8.05565 15.8823C8.01509 15.822 8.01277 15.7456 8.05565 15.7154C8.09852 15.6853 8.17152 15.7154 8.21208 15.7745C8.25263 15.8336 8.25495 15.9124 8.21208 15.9425Z",
      className: "filled"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M8.58982 16.3319C8.55158 16.3748 8.47395 16.3632 8.41021 16.3052C8.34648 16.2473 8.33258 16.1685 8.37082 16.1268C8.40906 16.0851 8.48669 16.0955 8.55158 16.1534C8.61647 16.2114 8.63037 16.2902 8.58982 16.3319Z",
      className: "filled"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M9.11126 16.5578C9.09503 16.6123 9.01624 16.6378 8.93629 16.6146C8.85634 16.5914 8.80535 16.5266 8.82041 16.4709C8.83548 16.4153 8.91659 16.3898 8.99538 16.4142C9.07418 16.4385 9.12632 16.5022 9.11126 16.5578Z",
      className: "filled"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M9.68367 16.5984C9.68367 16.6563 9.61878 16.7038 9.53535 16.705C9.45193 16.7062 9.38472 16.661 9.38356 16.6042C9.3824 16.5474 9.44961 16.4987 9.53304 16.4964C9.61647 16.4941 9.68367 16.5416 9.68367 16.5984V16.5984Z",
      className: "filled"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M10.2167 16.5092C10.2271 16.566 10.1692 16.6251 10.0869 16.639C10.0046 16.6529 9.93048 16.6193 9.92005 16.5625C9.90962 16.5057 9.96871 16.4466 10.0498 16.4327C10.1309 16.4188 10.2063 16.4524 10.2167 16.5092Z",
      className: "filled"
    })]
  }));
};
;// CONCATENATED MODULE: ./app/components/Landing/LandingFooter.tsx




const StyledLandingFooter = /*#__PURE__*/(0,styled/* default */.Z)("footer")({
  name: "StyledLandingFooter",
  class: "s1qkwdjf"
});
const LandingFooter = ({
  year = 2022
}) => {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledLandingFooter, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      className: "srOnly",
      children: "Footer"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "content",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "footer-primary",
        children: "\xA0"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "footer-secondary",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "footer-copyright",
          children: ["\xA9 ", year, " Vidbase, Inc. All rights reserved."]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "footer-social",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(IconButton, {
                as: "a",
                href: "https://twitter.com/VidbaseApp",
                alt: "VidbaseApp on Twitter",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(TwitterIcon, {
                  size: "2rem",
                  color: "var(--clr-gray)",
                  enableFilters: false
                })
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(IconButton, {
                as: "a" // href="https://www.youtube.com/channel/UCRa6hy6J79kGFLr_gvlEZGw"
                ,
                href: "https://www.youtube.com/channel/UCguQr6z-wZB1Fd0oWMtPO_g",
                alt: "Vidbase on YouTube",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(YouTubeIcon, {
                  size: "2rem",
                  color: "var(--clr-gray)",
                  enableFilters: false
                })
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(IconButton, {
                as: "a",
                href: "https://www.tiktok.com/@vidbase",
                alt: "Vidbase on TikTok",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(TikTokIcon, {
                  size: "2rem",
                  color: "var(--clr-gray)",
                  enableFilters: false
                })
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(IconButton, {
                as: "a",
                href: "https://www.linkedin.com/company/vidbase",
                alt: "Vidbase on LinkedIn",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(LinkedInIcon, {
                  size: "2rem",
                  color: "var(--clr-gray)",
                  enableFilters: false
                })
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(IconButton, {
                as: "a",
                href: "https://github.com/vidbase",
                alt: "Vidbase on Github",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(GithubIcon, {
                  size: "2rem",
                  color: "var(--clr-gray)",
                  enableFilters: false
                })
              })
            })]
          })
        })]
      })]
    })]
  });
};

__webpack_require__(9639);
// EXTERNAL MODULE: ../../node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6277);
// EXTERNAL MODULE: ../../node_modules/next-i18next/dist/esm/index.js + 12 modules
var esm = __webpack_require__(362);
;// CONCATENATED MODULE: ../../packages/styleguide/src/icons/VidbaseIcon.tsx


function VidbaseIcon_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function VidbaseIcon_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      VidbaseIcon_ownKeys(Object(source), true).forEach(function (key) {
        (0,defineProperty/* default */.Z)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      VidbaseIcon_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}




const VidbaseIcon = props => {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(AbstractIcon, VidbaseIcon_objectSpread(VidbaseIcon_objectSpread({}, props), {}, {
    "data-icon": "VidbaseIcon",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M16.0292 7.71375L13.4303 9.66529C13.2869 9.77369 13.1145 9.83714 12.9351 9.84761C12.7556 9.85809 12.577 9.81512 12.422 9.72415L5.97417 5.94963C5.91085 5.9103 5.85792 5.85631 5.81985 5.79223C5.78178 5.72814 5.75969 5.65584 5.75544 5.58142C5.75119 5.507 5.7649 5.43265 5.79542 5.36465C5.82594 5.29665 5.87238 5.23698 5.93081 5.1907L6.70523 4.60369C7.37813 4.09372 8.18594 3.79251 9.02845 3.73745C9.87097 3.68238 10.7111 3.87587 11.4447 4.29392L15.9859 6.95482C16.051 6.99266 16.1057 7.04606 16.1452 7.11025C16.1846 7.17444 16.2075 7.24741 16.2118 7.32262C16.2161 7.39783 16.2017 7.47293 16.1698 7.54119C16.1379 7.60946 16.0896 7.66875 16.0292 7.71375Z",
        className: "filled"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M18.4052 9.77526C18.372 9.72017 18.3277 9.67257 18.2751 9.63548C18.2225 9.5984 18.1628 9.57263 18.0998 9.55982C18.0368 9.54701 17.9717 9.54743 17.9089 9.56105C17.846 9.57467 17.7866 9.6012 17.7345 9.63896L10.3001 15.2039C10.0314 15.4104 9.73261 15.5744 9.41419 15.6903V11.1816C9.41303 11.0209 9.36945 10.8634 9.28786 10.725C9.20627 10.5865 9.08956 10.4721 8.94954 10.3932L5.68768 8.48043C5.61797 8.44224 5.53963 8.42257 5.46015 8.42331C5.38067 8.42404 5.3027 8.44515 5.23371 8.48462C5.16472 8.52409 5.107 8.5806 5.06608 8.64874C5.02517 8.71689 5.00241 8.79439 5 8.87384V15.8808C5.00041 17.0455 5.46337 18.1623 6.28708 18.9858C7.11079 19.8092 8.22781 20.2717 9.3925 20.2717H9.41419C10.3553 20.2696 11.2706 19.9638 12.024 19.3997L17.2327 15.4967C18.0953 14.8525 18.6918 13.9144 18.9093 12.8601C19.1268 11.8057 18.9502 10.7082 18.4129 9.77526H18.4052Z",
        className: "filled"
      })]
    })
  }));
};
;// CONCATENATED MODULE: ../../packages/styleguide/src/components/Wordmark.tsx


function Wordmark_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function Wordmark_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      Wordmark_ownKeys(Object(source), true).forEach(function (key) {
        (0,defineProperty/* default */.Z)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      Wordmark_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}




const StyledWordmark = /*#__PURE__*/(0,styled/* default */.Z)("svg")({
  name: "StyledWordmark",
  class: "s38r9xq",
  vars: {
    "s38r9xq-0": [props => props.fill || 'var(--clr-text)']
  }
});
const Wordmark = _ref => {
  let props = Object.assign({}, _ref);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(StyledWordmark, Wordmark_objectSpread(Wordmark_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 369.75 68.35"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
      id: "Layer_2",
      "data-name": "Layer 2",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
        id: "Logo",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
          id: "wordmark",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
            className: "cls-1",
            d: "M65.24,3.84l-28,64h-9L0,3.84H9.87l23,52.54L56.1,3.84Z"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
            className: "cls-1",
            d: "M74.71,9.78a5.4,5.4,0,0,1-1.69-4,5.53,5.53,0,0,1,1.69-4.06A5.75,5.75,0,0,1,79,0a5.92,5.92,0,0,1,4.25,1.6,5.24,5.24,0,0,1,1.69,4,5.64,5.64,0,0,1-1.69,4.16A5.75,5.75,0,0,1,79,11.42,5.87,5.87,0,0,1,74.71,9.78Z"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
            className: "cls-1",
            x: "74.57",
            y: "19.37",
            width: "8.77",
            height: "48.43"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
            className: "cls-1",
            d: "M143.72,0V67.8h-8.41V60.12a18.93,18.93,0,0,1-7.4,6.12A22.84,22.84,0,0,1,118,68.35a25.48,25.48,0,0,1-12.61-3.11,22.34,22.34,0,0,1-8.73-8.73,26,26,0,0,1-3.15-12.92A25.75,25.75,0,0,1,96.7,30.7,22.48,22.48,0,0,1,105.43,22,25.48,25.48,0,0,1,118,18.91a23.25,23.25,0,0,1,9.6,2,18.54,18.54,0,0,1,7.3,5.8V0ZM127.09,58.52a15.16,15.16,0,0,0,5.85-6,18.51,18.51,0,0,0,2.1-8.9,18.5,18.5,0,0,0-2.1-8.91,14.87,14.87,0,0,0-5.85-6,17.61,17.61,0,0,0-16.68,0,15.13,15.13,0,0,0-5.85,6,18.08,18.08,0,0,0-2.15,8.91,18.09,18.09,0,0,0,2.15,8.9,15.43,15.43,0,0,0,5.85,6,17.25,17.25,0,0,0,16.68,0Z"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
            className: "cls-1",
            d: "M195,22a22.35,22.35,0,0,1,8.73,8.68,25.75,25.75,0,0,1,3.15,12.89,26,26,0,0,1-3.15,12.92A22.21,22.21,0,0,1,195,65.24a25.48,25.48,0,0,1-12.61,3.11,22.84,22.84,0,0,1-9.87-2.11,18.93,18.93,0,0,1-7.4-6.12V67.8h-8.4V0h8.77V26.68a18.57,18.57,0,0,1,7.31-5.8,23.17,23.17,0,0,1,9.59-2A25.48,25.48,0,0,1,195,22Zm-5,36.5a15.43,15.43,0,0,0,5.85-6,18.09,18.09,0,0,0,2.15-8.9,18.08,18.08,0,0,0-2.15-8.91,15.13,15.13,0,0,0-5.85-6,17.61,17.61,0,0,0-16.68,0,14.78,14.78,0,0,0-5.84,6,18.28,18.28,0,0,0-2.11,8.91,18.29,18.29,0,0,0,2.11,8.9,15.07,15.07,0,0,0,5.84,6,17.25,17.25,0,0,0,16.68,0Z"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
            className: "cls-1",
            d: "M264.11,19.37V67.8H255.7V60.12a18.86,18.86,0,0,1-7.4,6.12,22.78,22.78,0,0,1-9.87,2.11,25.48,25.48,0,0,1-12.61-3.11,22.25,22.25,0,0,1-8.72-8.73,25.85,25.85,0,0,1-3.16-12.92A25.65,25.65,0,0,1,217.1,30.7,22.39,22.39,0,0,1,225.82,22a25.48,25.48,0,0,1,12.61-3.11,23.22,23.22,0,0,1,9.6,2,18.64,18.64,0,0,1,7.31,5.8V19.37ZM247.48,58.52a15,15,0,0,0,5.85-6,18.4,18.4,0,0,0,2.1-8.9,18.39,18.39,0,0,0-2.1-8.91,14.74,14.74,0,0,0-5.85-6,17.61,17.61,0,0,0-16.68,0,15.19,15.19,0,0,0-5.85,6,18.07,18.07,0,0,0-2.14,8.91,18.09,18.09,0,0,0,2.14,8.9,15.5,15.5,0,0,0,5.85,6,17.25,17.25,0,0,0,16.68,0Z"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
            className: "cls-1",
            d: "M281.76,66.75a25.19,25.19,0,0,1-8.59-4.07l3.66-6.94a26.09,26.09,0,0,0,7.76,3.65,31.76,31.76,0,0,0,9.23,1.37q11.51,0,11.51-6.58a4.24,4.24,0,0,0-1.55-3.47,10,10,0,0,0-3.88-1.87q-2.34-.6-6.63-1.33a65.37,65.37,0,0,1-9.55-2.1,14.74,14.74,0,0,1-6.35-4c-1.76-1.89-2.65-4.54-2.65-8a12.4,12.4,0,0,1,5.49-10.55q5.48-4,14.71-4a40.64,40.64,0,0,1,9.68,1.19,26,26,0,0,1,7.95,3.2l-3.74,6.94a25.23,25.23,0,0,0-14-3.83q-5.56,0-8.49,1.82a5.53,5.53,0,0,0-2.93,4.85,4.6,4.6,0,0,0,1.65,3.74,10.26,10.26,0,0,0,4.06,2q2.43.64,6.81,1.47a74.44,74.44,0,0,1,9.46,2.14,14.26,14.26,0,0,1,6.17,3.89q2.55,2.73,2.55,7.67a12.1,12.1,0,0,1-5.61,10.46q-5.62,3.89-15.31,3.89A40.82,40.82,0,0,1,281.76,66.75Z"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
            className: "cls-1",
            d: "M369.57,46.51H330.28a15.22,15.22,0,0,0,5.62,10.28,18.33,18.33,0,0,0,11.92,3.88q8.69,0,14-5.85l4.84,5.67a21.14,21.14,0,0,1-8.17,5.85,30.82,30.82,0,0,1-24.54-1.15,22.47,22.47,0,0,1-9.18-8.81,25.33,25.33,0,0,1-3.24-12.79,25.71,25.71,0,0,1,3.15-12.71,22.55,22.55,0,0,1,8.68-8.81,24.62,24.62,0,0,1,12.47-3.16,24.13,24.13,0,0,1,12.38,3.16,22.18,22.18,0,0,1,8.5,8.81,26.91,26.91,0,0,1,3.06,13A25.58,25.58,0,0,1,369.57,46.51ZM335.26,30.15a15.5,15.5,0,0,0-5,10.05h31.07a15.59,15.59,0,0,0-5-10,16.35,16.35,0,0,0-21.11-.05Z"
          })]
        })
      })
    })
  }));
};

__webpack_require__(3312);
;// CONCATENATED MODULE: ../../packages/styleguide/src/components/Link.tsx


const Link_excluded = ["children"];

function Link_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function Link_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      Link_ownKeys(Object(source), true).forEach(function (key) {
        (0,defineProperty/* default */.Z)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      Link_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}



const StyledTextLink = /*#__PURE__*/(0,styled/* default */.Z)("a")({
  name: "StyledTextLink",
  class: "sp89y53",
  vars: {
    "sp89y53-0": [props => props.color || 'var(--clr-blue)'],
    "sp89y53-1": [props => props.fontWeight || 600],
    "sp89y53-2": [props => props.size ? props.size : 'var(--font-size-2sm)']
  }
});
const TextLink = _ref => {
  let {
    children
  } = _ref,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, Link_excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsx)(StyledTextLink, Link_objectSpread(Link_objectSpread({
    prefetch: false
  }, props), {}, {
    children: children
  }));
};

__webpack_require__(3585);
;// CONCATENATED MODULE: ../../packages/styleguide/src/components/Button.tsx


const Button_excluded = ["children", "alt"],
      Button_excluded2 = (/* unused pure expression or super */ null && (["children", "alt"]));

function Button_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function Button_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      Button_ownKeys(Object(source), true).forEach(function (key) {
        (0,defineProperty/* default */.Z)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      Button_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}





const StyledButton = /*#__PURE__*/(0,styled/* default */.Z)("button")({
  name: "StyledButton",
  class: "s16vnj57",
  vars: {
    "s16vnj57-0": [props => props.size ? props.size : 'var(--font-size-2sm)'],
    "s16vnj57-1": [() => "url(/img/noise-light.svg), var(--clr-blue)"]
  }
});
const Button = _ref => {
  let {
    children,
    alt = ''
  } = _ref,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, Button_excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledButton, Button_objectSpread(Button_objectSpread({}, props), {}, {
    className: (0,clsx_m/* default */.Z)('button', props.className || ''),
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      className: "toggle-size",
      children: children
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      className: "label",
      children: alt || children
    })]
  }));
};
const StyledEmojiButton = /*#__PURE__*/(0,styled/* default */.Z)(StyledButton)({
  name: "StyledEmojiButton",
  class: "s1o8snp4"
});
const EmojiButton = _ref2 => {
  let {
    children,
    alt = ''
  } = _ref2,
      props = _objectWithoutProperties(_ref2, Button_excluded2);

  return /*#__PURE__*/_jsxs(StyledEmojiButton, Button_objectSpread(Button_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("span", {
      className: "toggle-size",
      children: children
    }), /*#__PURE__*/_jsx("span", {
      className: "label",
      children: alt || children
    })]
  }));
};

__webpack_require__(8519);
;// CONCATENATED MODULE: ../../packages/styleguide/src/components/HamburgerButton.tsx


function HamburgerButton_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function HamburgerButton_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      HamburgerButton_ownKeys(Object(source), true).forEach(function (key) {
        (0,defineProperty/* default */.Z)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      HamburgerButton_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}






const NOOP = () => null;

const StyledHamburger = /*#__PURE__*/(0,styled/* default */.Z)("button")({
  name: "StyledHamburger",
  class: "snlgog7",
  vars: {
    "snlgog7-0": [props => props.scale ? "scale(".concat(props.scale, ")") : 'none']
  }
});
const StyledHamburgerIcon = /*#__PURE__*/(0,styled/* default */.Z)("div")({
  name: "StyledHamburgerIcon",
  class: "shsqkjt",
  vars: {
    "shsqkjt-0": [() => "url('/api/noise.svg?opacity=.4'), var(--clr-primary)"]
  }
});
const HamburgerIcon = props => {
  return /*#__PURE__*/_jsx(StyledHamburgerIcon, {
    className: cls('hamburger-icon', {
      active: props.open === true
    }),
    children: /*#__PURE__*/_jsx("div", {
      className: "hamburger-inner"
    })
  });
};
const HamburgerButton = props => {
  const {
    0: isOpen,
    1: setIsOpen
  } = (0,react.useState)(false);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(StyledHamburger, HamburgerButton_objectSpread(HamburgerButton_objectSpread({}, props), {}, {
    "aria-label": "hamburger menu",
    onClick: event => {
      setIsOpen(!isOpen);
      return (props.onClick || NOOP)(event);
    },
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (0,clsx_m/* default */.Z)('hamburger-icon', {
        active: isOpen == true
      }),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "hamburger-inner"
      })
    })
  }));
};

__webpack_require__(1384);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs + 3 modules
var AnimatePresence = __webpack_require__(4589);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/render/dom/motion.mjs + 174 modules
var motion = __webpack_require__(5982);
;// CONCATENATED MODULE: ../../packages/styleguide/src/icons/ChevronIcon.tsx


function ChevronIcon_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function ChevronIcon_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ChevronIcon_ownKeys(Object(source), true).forEach(function (key) {
        (0,defineProperty/* default */.Z)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ChevronIcon_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}



const ChevronIcon = props => {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(AbstractIcon, ChevronIcon_objectSpread(ChevronIcon_objectSpread({}, props), {}, {
    "data-icon": "ChevronIcon",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M5 9L11.2929 15.2929C11.6834 15.6834 12.3166 15.6834 12.7071 15.2929L19 9",
        className: "stroke",
        strokeWidth: "1.6",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      })
    })
  }));
};
;// CONCATENATED MODULE: ./app/components/Landing/components/HeaderNav/HeaderNav.tsx


const HeaderNav_excluded = ["children"],
      HeaderNav_excluded2 = ["children", "href", "value"],
      _excluded3 = ["children"];

function HeaderNav_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function HeaderNav_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { HeaderNav_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { HeaderNav_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }








const spring = {
  type: 'spring',
  stiffness: 500,
  damping: 30
};
const StyledHeaderNav = /*#__PURE__*/(0,styled/* default */.Z)(motion/* motion.nav */.E.nav)({
  name: "StyledHeaderNav",
  class: "s1nz4i4"
});
const Underline = () => {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
    className: "underline",
    layoutId: "underline" // layout
    ,
    initial: false,
    animate: {
      left: 0
    } // animate={{ left: '0px', right: '0px', bottom: '-1px' }}
    ,
    transition: spring // initial={{ left: '25%', right: '25%', bottom: '-2px' }}
    // animate={{ left: '0px', right: '0px', bottom: '-1px' }}
    // transition={{ easing: spring() }}

  });
};
const StyledSubMenuItems = /*#__PURE__*/(0,styled/* default */.Z)("div")({
  name: "StyledSubMenuItems",
  class: "se9jedg"
});
const SubMenuItemsVariants = {
  hidden: {
    opacity: 1,
    left: '-50%'
  },
  visible: {
    opacity: 1,
    left: '-50%',
    transition: {
      delayChildren: 0.1,
      staggerChildren: 0.05
    }
  },
  exit: {
    opacity: 0,
    transformOrigin: '50% -50px',
    transform: 'rotateX(-50deg)'
  }
};
const SubMenuItems = _ref => {
  let {
    children
  } = _ref,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, HeaderNav_excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsx)(StyledSubMenuItems, HeaderNav_objectSpread(HeaderNav_objectSpread({}, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(motion/* motion.div */.E.div, {
      className: "menu-flyout",
      layoutId: "menu",
      variants: SubMenuItemsVariants,
      style: {
        minWidth: '200px'
      },
      initial: "hidden",
      animate: "visible",
      transition: spring,
      exit: "exit",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "flyout-arrow"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "flyout-arrow-shadow"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "flyout-content",
        children: children
      })]
    })
  }));
};
const StyledMenuItem = /*#__PURE__*/(0,styled/* default */.Z)(motion/* motion.div */.E.div)({
  name: "StyledMenuItem",
  class: "sgtbiul"
});
const MenuItem = _ref2 => {
  let {
    children = null,
    href = null,
    value
  } = _ref2,
      props = (0,objectWithoutProperties/* default */.Z)(_ref2, HeaderNav_excluded2);

  const {
    0: isHovering,
    1: setIsHovering
  } = (0,react.useState)(false);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledMenuItem, HeaderNav_objectSpread(HeaderNav_objectSpread({}, props), {}, {
    onHoverStart: () => {
      setIsHovering(true);
    },
    onHoverEnd: () => {
      setIsHovering(false);
    },
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
      className: "nav-menu-item",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
        href: href,
        className: (0,clsx_m/* default */.Z)('nav-menu-label', {
          glowing: isHovering
        }),
        children: [value, children && /*#__PURE__*/(0,jsx_runtime.jsx)(ChevronIcon, {
          size: "1rem",
          hasGlow: isHovering,
          color: isHovering ? 'var(--clr-white)' : 'var(--clr-text)'
        })]
      }), isHovering && /*#__PURE__*/(0,jsx_runtime.jsx)(Underline, {})]
    }), children && /*#__PURE__*/(0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
      children: isHovering && /*#__PURE__*/(0,jsx_runtime.jsx)(SubMenuItems, {
        children: children
      })
    })]
  }));
};
const HeaderNav = _ref3 => {
  let props = Object.assign({}, _ref3);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledHeaderNav, HeaderNav_objectSpread(HeaderNav_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(MenuItem, {
      value: 'Use Cases',
      href: "#",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SubMenuItem, {
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
          href: "/use-cases/podcasts",
          title: "Use Case: Podcasters",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: "icon",
            children: "\uD83C\uDF99\uFE0F"
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
            className: "label-container",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: "label",
              children: "Podcasters"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: "desc",
              children: "Audio-only podcasts, interviews, and chats."
            })]
          })]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SubMenuItem, {
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
          href: "/use-cases/youtube",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: "icon",
            children: "\uD83D\uDCFA"
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
            className: "label-container",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: "label",
              children: "YouTubers"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: "desc",
              children: "Video essays, talking heads, tutorials, etc."
            })]
          })]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SubMenuItem, {
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
          href: "/use-cases/marketing",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: "icon",
            children: "\uD83D\uDCB8"
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
            className: "label-container",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: "label",
              children: "Marketers"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: "desc",
              children: "Video advertisements, real-estate, etc."
            })]
          })]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SubMenuItem, {
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
          href: "/use-cases/photography",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: "icon",
            children: "\uD83D\uDCF8"
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
            className: "label-container",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: "label",
              children: "Photographers"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: "desc",
              children: "Landscapes, portraits, street, product, etc."
            })]
          })]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SubMenuItem, {
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
          href: "/use-cases/videography",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: "icon",
            children: "\uD83C\uDFA5"
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
            className: "label-container",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: "label",
              children: "Videographers"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: "desc",
              children: "Wedding videos, music videos, promotional, etc."
            })]
          })]
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(MenuItem, {
      value: 'How it Works',
      href: "#",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SubMenuItem, {
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
          href: "/features/ui",
          title: "Features: UI",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: "icon",
            children: "\u26A1"
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
            className: "label-container",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: "label",
              children: "Lightning Fast UI"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: "desc",
              children: "High performance, from the ground up."
            })]
          })]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SubMenuItem, {
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
          href: "/features/ml",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: "icon",
            children: "\uD83E\uDDE0"
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
            className: "label-container",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: "label",
              children: "ML-powered Automation"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: "desc",
              children: "Skip all of the busywork."
            })]
          })]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SubMenuItem, {
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
          href: "/features/collab",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: "icon",
            children: "\uD83D\uDC8F"
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
            className: "label-container",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: "label",
              children: "Collaboration"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: "desc",
              children: "Work together in real-time."
            })]
          })]
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(MenuItem, {
      value: 'Pricing',
      href: "/pricing"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(MenuItem, {
      value: 'Company',
      href: "/about"
    })]
  }));
};
const StyledSubMenuItem = /*#__PURE__*/(0,styled/* default */.Z)(motion/* motion.div */.E.div)({
  name: "StyledSubMenuItem",
  class: "s1ycdsrt"
});
const SubMenuItemVariants = {
  hidden: {
    x: 40,
    opacity: 0
  },
  visible: {
    x: 0,
    opacity: 1
  }
};
const SubMenuItem = _ref4 => {
  let {
    children
  } = _ref4,
      props = (0,objectWithoutProperties/* default */.Z)(_ref4, _excluded3);

  return /*#__PURE__*/(0,jsx_runtime.jsx)(StyledSubMenuItem, HeaderNav_objectSpread(HeaderNav_objectSpread({}, props), {}, {
    layout: true,
    variants: SubMenuItemVariants,
    transition: spring,
    children: children
  }));
};

__webpack_require__(961);
;// CONCATENATED MODULE: ./app/components/Landing/components/HeaderNav/index.ts

// EXTERNAL MODULE: ../../node_modules/next/image.js
var next_image = __webpack_require__(6577);
;// CONCATENATED MODULE: ../../packages/styleguide/src/icons/PlayCircleIcon.tsx


function PlayCircleIcon_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function PlayCircleIcon_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      PlayCircleIcon_ownKeys(Object(source), true).forEach(function (key) {
        (0,defineProperty/* default */.Z)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      PlayCircleIcon_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}




const PlayCircleIcon = props => {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(AbstractIcon, PlayCircleIcon_objectSpread(PlayCircleIcon_objectSpread({}, props), {}, {
    "data-icon": "PlayCircleIcon",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M17.2 12.866C17.8667 12.4811 17.8667 11.5189 17.2 11.134L9.80771 6.86602C9.14104 6.48112 8.30771 6.96225 8.30771 7.73205L8.30771 16.2679C8.30771 17.0377 9.14104 17.5189 9.80771 17.134L17.2 12.866Z",
        className: "filled"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12Z",
        className: "filled"
      })]
    })
  }));
};
// EXTERNAL MODULE: ../../node_modules/@react-three/fiber/dist/react-three-fiber.esm.js + 3 modules
var react_three_fiber_esm = __webpack_require__(8829);
// EXTERNAL MODULE: ../../node_modules/@react-three/drei/core/Points.js
var Points = __webpack_require__(6783);
// EXTERNAL MODULE: ../../node_modules/@react-three/drei/core/PointMaterial.js
var PointMaterial = __webpack_require__(2564);
// EXTERNAL MODULE: ../../node_modules/@react-three/drei/core/useDetectGPU.js + 2 modules
var useDetectGPU = __webpack_require__(1019);
// EXTERNAL MODULE: ../../node_modules/@react-three/postprocessing/dist/index.js + 1 modules
var dist = __webpack_require__(8133);
// EXTERNAL MODULE: ../../node_modules/maath/random/dist/maath-random.esm.js + 3 modules
var maath_random_esm = __webpack_require__(482);
;// CONCATENATED MODULE: ./app/components/Landing/sections/LandingSplash.tsx


const LandingSplash_excluded = ["speed"],
      LandingSplash_excluded2 = ["speed"];

function LandingSplash_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function LandingSplash_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { LandingSplash_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { LandingSplash_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }













const StyledLandingSplash = /*#__PURE__*/(0,styled/* default */.Z)("main")({
  name: "StyledLandingSplash",
  class: "saq2o3y"
});
function Stars(_ref) {
  let {
    speed
  } = _ref,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, LandingSplash_excluded);

  const ref = (0,react.useRef)();
  const {
    0: sphere
  } = (0,react.useState)(() => maath_random_esm/* inSphere */.Qm(new Float32Array(26000), {
    radius: 15
  }));
  (0,react_three_fiber_esm/* useFrame */.xQ)((_state, delta) => {
    // @ts-ignore
    // ref.current.rotation.x -= delta / speed / 100
    // @ts-ignore
    ref.current.rotation.y -= delta / speed;
  });
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("group", {
      rotation: [0, 0, Math.PI / 2.55],
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Points/* Points */.wo // @ts-ignore
      , LandingSplash_objectSpread(LandingSplash_objectSpread({
        ref: ref,
        positions: sphere,
        stride: 3,
        frustumCulled: false
      }, props), {}, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(PointMaterial/* PointMaterial */.C // @ts-ignore
        , {
          transparent: true,
          color: "#ffffff",
          size: 0.008,
          sizeAttenuation: true,
          depthWrite: false
        })
      }))
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(dist/* EffectComposer */.xC, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(dist/* DepthOfField */.y8, {
        focusDistance: 1.1,
        focalLength: 0.35,
        bokehScale: 1
      })
    })]
  });
}
const LandingBackground = _ref2 => {
  let {
    speed
  } = _ref2,
      props = (0,objectWithoutProperties/* default */.Z)(_ref2, LandingSplash_excluded2);

  const GPUTier = (0,useDetectGPU/* useDetectGPU */.l)();
  const {
    0: shouldShowCanvas,
    1: setShouldShowCanvas
  } = (0,react.useState)(false);
  (0,react.useEffect)(() => {
    if (GPUTier.tier != 0 && !GPUTier.isMobile) {
      setShouldShowCanvas(true);
    }
  }, []);

  if (!shouldShowCanvas) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
      className: "hero-bg-nogpu",
      src: "/img/landing-bg.png",
      alt: "landing background for low performance devices"
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(react_three_fiber_esm/* Canvas */.Xz, {
    mode: "concurrent",
    camera: {
      position: [0, 0, 0]
    },
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Stars, {
      speed: speed
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("ambientLight", {})]
  });
};
const DEFAULT_SPEED = 100;
const LandingSplash_spring = {
  type: 'spring',
  stiffness: 500,
  damping: 30
};
const splashParentVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      delayChildren: 0.1,
      staggerChildren: 0.5
    }
  }
};
const splashVariants = {
  hidden: {
    opacity: 0,
    y: -50
  },
  visible: {
    opacity: 1,
    y: 0
  }
};
const LandingSplash = () => {
  const {
    0: finalSpring,
    1: setFinalSpring
  } = (0,react.useState)(LandingSplash_spring);
  const {
    0: speed,
    1: setSpeed
  } = (0,react.useState)(DEFAULT_SPEED);
  const {
    0: isHoveringVideo,
    1: setIsHoveringVideo
  } = (0,react.useState)(false);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledLandingSplash, {
    className: "hero",
    onMouseDown: e => {
      if (e.button == 0) {
        setSpeed(1 / 5);
      }
    },
    onMouseUp: e => {
      if (e.button == 0) {
        setSpeed(DEFAULT_SPEED);
      }
    },
    onBlur: () => {
      setSpeed(DEFAULT_SPEED);
    },
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "hero-background",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(react.Suspense, {
        fallback: null,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(LandingBackground, {
          speed: speed
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "hero-splash",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "hero-splash-container",
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(motion/* motion.h1 */.E.h1, {
            variants: splashVariants,
            initial: 'hidden',
            animate: 'visible',
            transition: LandingSplash_objectSpread(LandingSplash_objectSpread({}, finalSpring), {}, {
              delay: 0.15
            }),
            children: ["\uD83C\uDF99\uFE0F Edit Podcasts &", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "\uD83D\uDCFA YouTube Videos", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "in ", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: "gradient-text",
              children: "Minutes."
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(motion/* motion.p */.E.p, {
            variants: splashVariants,
            initial: 'hidden',
            animate: 'visible',
            transition: LandingSplash_objectSpread(LandingSplash_objectSpread({}, finalSpring), {}, {
              delay: 0.25
            }),
            children: ["Whether you create audio-only", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              className: "highlighter",
              href: "/use-cases/podcasts",
              children: "podcasts"
            }), ",", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              className: "highlighter",
              href: "/use-cases/youtube",
              children: "YouTube videos"
            }), ", or", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              className: "highlighter",
              href: "/use-cases/marketing",
              children: "marketing ads"
            }), ' ', "- Vidbase enables you to focus entirely on telling amazing stories by automating the most tedious and boring parts of media editing so you can live your life."]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
            className: "flex",
            variants: splashVariants,
            initial: 'hidden',
            animate: 'visible',
            transition: LandingSplash_objectSpread(LandingSplash_objectSpread({}, finalSpring), {}, {
              delay: 0.35
            }),
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "cta buttonWrap",
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Button, {
                as: "a",
                href: "https://vid.bs/signup",
                draggable: false,
                children: ["Request Access ", '->']
              })
            })
          })]
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "hero-screenshot",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "hero-screenshot-bg"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
        className: "hero-screenshot-figure",
        variants: splashVariants,
        initial: 'hidden',
        animate: 'visible',
        transition: LandingSplash_objectSpread(LandingSplash_objectSpread({}, finalSpring), {}, {
          delay: 0.55
        }),
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "img-container",
          onMouseOver: () => {
            setIsHoveringVideo(true);
          },
          onMouseOut: () => {
            setIsHoveringVideo(false);
          },
          onBlur: () => {
            setIsHoveringVideo(false);
          },
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(next_image["default"], {
            src: "/img/vidbase-screenshot.png",
            alt: "placeholder",
            width: "1024",
            height: "576",
            priority: true
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(PlayCircleIcon, {
            className: "playicon",
            size: "10rem",
            color: isHoveringVideo == true ? 'var(--clr-text-bright)' : 'var(--clr-text)'
          })]
        })
      })]
    })]
  });
};

__webpack_require__(4011);
;// CONCATENATED MODULE: ./app/components/Landing/LandingHeader.tsx


const LandingHeader_excluded = ["session"];

function LandingHeader_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function LandingHeader_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { LandingHeader_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { LandingHeader_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }











const StyledLandingHeader = /*#__PURE__*/(0,styled/* default */.Z)("header")({
  name: "StyledLandingHeader",
  class: "skj5tf0"
});
const mobileMenuVariants = {
  hidden: {
    opacity: 0,
    x: 150
  },
  visible: {
    opacity: 1,
    x: 0
  },
  exit: {
    opacity: 0,
    x: 150
  }
};
const FullMenuData = [{
  name: t => 'Use Cases',
  children: [{
    icon: () => '🎙️',
    href: '/use-cases/podcasts',
    label: t => 'Podcasters',
    desc: t => 'Audio-only podcasts, interviews, and chats.'
  }, {
    icon: () => '📺',
    href: '/use-cases/youtube',
    label: t => 'YouTubers',
    desc: t => 'Video essays, talking heads, tutorials, etc.'
  }, {
    icon: () => '💸',
    href: '/use-cases/marketing',
    label: t => 'Marketers',
    desc: t => 'Video advertisements, real-estate, etc.'
  }, {
    icon: () => '📸',
    href: '/use-cases/photography',
    label: t => 'Photographers',
    desc: t => 'Landscapes, portraits, street, product, etc.'
  }, {
    icon: () => '🎥',
    href: '/use-cases/videography',
    label: t => 'Videographers',
    desc: t => 'Wedding videos, music videos, promotional, etc.'
  }]
}, {
  name: t => 'How it Works',
  children: [{
    icon: () => '⚡',
    href: '/features/ui',
    label: t => 'Lightning Fast UI',
    desc: t => 'High performance, from the ground up.'
  }, {
    icon: () => '🧠',
    href: '/features/ml',
    label: t => 'ML-powered Automation',
    desc: t => 'Skip all of the busywork.'
  }, {
    icon: () => '💏',
    href: '/features/collab',
    label: t => 'Collaboration',
    desc: t => 'Work together in real-time.'
  }]
}, {
  name: t => 'Pricing',
  href: '/pricing'
}, {
  name: t => 'Company',
  href: '/about'
}];
const LandingHeader = _ref => {
  var _session$user;

  let {
    session
  } = _ref,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, LandingHeader_excluded);

  const {
    t
  } = (0,esm/* useTranslation */.$G)();
  const {
    0: isMobileMenuOpen,
    1: setIsMobileMenuOpen
  } = (0,react.useState)(false);
  const {
    0: scrollYPos,
    1: setScrollYPos
  } = (0,react.useState)(0);
  const {
    0: MobileMenu,
    1: setMobileMenu
  } = (0,react.useState)([]);

  const handleScroll = () => {
    setScrollYPos(window.scrollY);
  };

  (0,react.useEffect)(() => {
    window.addEventListener('scroll', handleScroll);
    setMobileMenu(() => {
      return FullMenuData.map(d => {
        return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "m-menu-section",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            className: "m-menu-section-heading",
            href: d.href || '#',
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
              children: d.name(t)
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
            children: (d.children || []).map((row, index) => {
              return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  href: row.href,
                  children: row.label(t)
                })
              }, "m-menu-row-".concat(d.name, "-").concat(index));
            })
          })]
        }, "m-menu-".concat(d.name));
      });
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const isLoggedIn = !!(session !== null && session !== void 0 && (_session$user = session.user) !== null && _session$user !== void 0 && _session$user.id) || false;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(StyledLandingHeader, LandingHeader_objectSpread(LandingHeader_objectSpread({}, props), {}, {
    className: (0,clsx_m/* default */.Z)(props.className || '', {
      sticky: scrollYPos !== 0
    }),
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "headerContent",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
        href: "/",
        className: "goHome",
        title: t('landing:dashboard'),
        draggable: false,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(VidbaseIcon, {
          size: "44px",
          color: 'var(--clr-blue)',
          enableFilters: false
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Wordmark, {
          height: "1rem",
          fill: 'var(--clr-white)',
          enableFilters: false
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(HeaderNav, {
        className: "desktop-up"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "actions desktop-up",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextLink, {
          href: "https://edit.vidbase.app/",
          size: 'var(--font-size-2sm)',
          color: 'var(--clr-blue)',
          draggable: false,
          children: t('common:login')
        }), isLoggedIn == true ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "cta-btn",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Button, {
            as: "a",
            href: "https://edit.vidbase.app/",
            size: 'var(--font-size-2sm)',
            draggable: false,
            children: t('landing:dashboard')
          })
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "cta-btn",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Button, {
            as: "a",
            href: "https://vid.bs/signup",
            size: 'var(--font-size-2sm)',
            draggable: false,
            children: t('landing:requestAccess')
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "m-actions not-desktop",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(HamburgerButton, {
          onClick: () => {
            setIsMobileMenuOpen(!isMobileMenuOpen);
          }
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
        children: isMobileMenuOpen === true ? /*#__PURE__*/(0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
          className: "m-menu not-desktop",
          variants: mobileMenuVariants,
          initial: 'hidden',
          animate: 'visible',
          transition: LandingSplash_spring,
          exit: "exit",
          children: MobileMenu
        }) : null
      })]
    })
  }));
};

__webpack_require__(2557);
;// CONCATENATED MODULE: ./app/components/Landing/LandingLayout.tsx


const LandingLayout_excluded = ["children"];

function LandingLayout_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function LandingLayout_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { LandingLayout_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { LandingLayout_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




const StyledLandingLayout = /*#__PURE__*/(0,styled/* default */.Z)("div")({
  name: "StyledLandingLayout",
  class: "s1d5mrt4"
});
const LandingLayout = _ref => {
  let {
    children
  } = _ref,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, LandingLayout_excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsx)(StyledLandingLayout, LandingLayout_objectSpread(LandingLayout_objectSpread({}, props), {}, {
    className: (0,clsx_m/* default */.Z)('container', props.className || ''),
    children: children
  }));
};

__webpack_require__(8024);
;// CONCATENATED MODULE: ./app/components/Landing/components/index.ts

;// CONCATENATED MODULE: ./app/components/Landing/sections/LandingSection.tsx

const LandingSection_StyledLandingSection = /*#__PURE__*/(0,styled/* default */.Z)("section")({
  name: "StyledLandingSection",
  class: "s19ty74y",
  vars: {
    "s19ty74y-0": [props => props.bg || 'var(--clr-bg-noise)']
  }
});

__webpack_require__(9875);
;// CONCATENATED MODULE: ./app/components/Landing/sections/LandingFeatureOverview.tsx




const StyledFeatureCloud = /*#__PURE__*/(0,styled/* default */.Z)("div")({
  name: "StyledFeatureCloud",
  class: "s18mjt73"
});
const LandingFeatureOverview = () => {
  return /*#__PURE__*/_jsx(StyledLandingSection, {
    className: "featOverview",
    bg: 'var(--bg-nav)',
    children: /*#__PURE__*/_jsxs("div", {
      className: "content",
      children: [/*#__PURE__*/_jsxs("div", {
        className: "headline",
        children: [/*#__PURE__*/_jsx("h2", {
          className: "shadow",
          children: "A Desktop-Class Experience on the Web."
        }), /*#__PURE__*/_jsx("p", {
          children: "Optimized for modern production workflows."
        })]
      }), /*#__PURE__*/_jsxs(StyledFeatureCloud, {
        children: [/*#__PURE__*/_jsx("div", {
          className: "featurePreview",
          children: /*#__PURE__*/_jsxs("div", {
            className: "previewContent",
            children: [/*#__PURE__*/_jsx("h4", {
              children: "\u26A1 Lightning Fast"
            }), /*#__PURE__*/_jsx("p", {
              children: "Built solely for speed."
            }), /*#__PURE__*/_jsx("p", {
              children: "Opens in 6 seconds."
            }), /*#__PURE__*/_jsx("p", {
              children: "No spinners."
            })]
          })
        }), /*#__PURE__*/_jsx("div", {
          className: "featurePreview",
          children: /*#__PURE__*/_jsxs("div", {
            className: "previewContent",
            children: [/*#__PURE__*/_jsx("h4", {
              children: "\u2728 Magic Built-in"
            }), /*#__PURE__*/_jsx("p", {
              children: "Collaboration & syncing."
            }), /*#__PURE__*/_jsx("p", {
              children: "Feels like a native app."
            }), /*#__PURE__*/_jsx("p", {
              children: "Automated audio cleanup."
            })]
          })
        }), /*#__PURE__*/_jsx("div", {
          className: "featurePreview",
          children: /*#__PURE__*/_jsxs("div", {
            className: "previewContent",
            children: [/*#__PURE__*/_jsx("h4", {
              children: "\uD83E\uDDE0 Editor Copilot"
            }), /*#__PURE__*/_jsx("p", {
              children: "Organizes in seconds."
            }), /*#__PURE__*/_jsx("p", {
              children: "Rates your work."
            }), /*#__PURE__*/_jsx("p", {
              children: "Suggests edits."
            })]
          })
        }), /*#__PURE__*/_jsx("div", {
          className: "featurePreview",
          children: /*#__PURE__*/_jsxs("div", {
            className: "previewContent",
            children: [/*#__PURE__*/_jsx("h4", {
              children: "\uD83E\uDDE9 All-in-One"
            }), /*#__PURE__*/_jsx("p", {
              children: "Multi-track timelines."
            }), /*#__PURE__*/_jsx("p", {
              children: "Transcript editing."
            }), /*#__PURE__*/_jsx("p", {
              children: "Audio processing & more."
            })]
          })
        }), /*#__PURE__*/_jsx("div", {
          className: "featurePreview",
          children: /*#__PURE__*/_jsxs("div", {
            className: "previewContent",
            children: [/*#__PURE__*/_jsx("h4", {
              children: "\u2328\uFE0F Cross-Platform"
            }), /*#__PURE__*/_jsx("p", {
              children: "PC. Mac."
            }), /*#__PURE__*/_jsx("p", {
              children: "iPhone. Android."
            }), /*#__PURE__*/_jsx("p", {
              children: "Accessible by default."
            })]
          })
        }), /*#__PURE__*/_jsx("div", {
          className: "featurePreview",
          children: /*#__PURE__*/_jsxs("div", {
            className: "previewContent",
            children: [/*#__PURE__*/_jsx("h4", {
              children: "\uD83C\uDF24\uFE0F Works Offline"
            }), /*#__PURE__*/_jsx("p", {
              children: "Privacy by default."
            }), /*#__PURE__*/_jsx("p", {
              children: "Cloud-optional."
            }), /*#__PURE__*/_jsx("p", {
              children: "Pants are optional, too."
            })]
          })
        })]
      })]
    })
  });
};

__webpack_require__(110);
;// CONCATENATED MODULE: ../../packages/styleguide/src/icons/HistoryIcon.tsx


function HistoryIcon_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function HistoryIcon_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      HistoryIcon_ownKeys(Object(source), true).forEach(function (key) {
        (0,defineProperty/* default */.Z)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      HistoryIcon_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}




const HistoryIcon = props => {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(AbstractIcon, HistoryIcon_objectSpread(HistoryIcon_objectSpread({}, props), {}, {
    "data-icon": "HistoryIcon",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M16.0608 12L13.2574 12C12.7051 12 12.2574 11.5523 12.2574 11L12.2574 6.44138",
        className: "stroke",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M5.48349 12C5.48349 8.12219 8.62708 4.9786 12.5049 4.9786C16.3827 4.9786 19.5263 8.12219 19.5263 12C19.5263 15.8778 16.3827 19.0214 12.5049 19.0214C10.8967 19.0214 9.41478 18.4807 8.231 17.5713",
        className: "stroke",
        strokeLinecap: "round"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M5.15647 15.7343C5.3158 15.9605 5.65119 15.9605 5.81052 15.7343L7.99672 12.6303C8.18337 12.3653 7.99383 12 7.66969 12H3.2973C2.97316 12 2.78362 12.3653 2.97027 12.6303L5.15647 15.7343Z",
        className: "filled"
      })]
    })
  }));
};
;// CONCATENATED MODULE: ../../packages/styleguide/src/icons/EffectsIcon.tsx


function EffectsIcon_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function EffectsIcon_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      EffectsIcon_ownKeys(Object(source), true).forEach(function (key) {
        (0,defineProperty/* default */.Z)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      EffectsIcon_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}



const EffectsIcon = props => {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(AbstractIcon, EffectsIcon_objectSpread(EffectsIcon_objectSpread({}, props), {}, {
    "data-icon": "EffectsIcon",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M7 9.40675H8.97604L7.99451 15.2294C7.77269 16.3939 7.55642 17.3034 7.3457 17.9577C7.13497 18.6232 6.89098 18.9559 6.61371 18.9559C6.41407 18.9559 6.24771 18.8783 6.11462 18.723C5.97044 18.5788 5.83181 18.4125 5.69872 18.2239L5.33272 18.3404C5.31054 18.5844 5.26618 18.8506 5.19963 19.1389C5.122 19.4273 5.05545 19.6657 5 19.8543C5.13309 19.9097 5.28836 19.9541 5.46581 19.9874C5.63217 20.0206 5.77635 20.0373 5.89835 20.0373C6.0869 20.0373 6.2588 20.0095 6.41407 19.9541C6.55825 19.9097 6.69134 19.8543 6.81334 19.7877C7.55642 19.3552 8.20524 18.6786 8.75977 17.7581C9.31431 16.8487 9.72467 15.6342 9.99085 14.1148L10.7894 9.45666C11.0112 9.46775 11.2829 9.48993 11.6046 9.52321C11.9751 9.56154 12.5103 9.7093 12.8806 9.81156C13.0317 9.85327 13.1553 9.8874 13.2292 9.90346C13.2292 9.90372 13.2292 9.90321 13.2292 9.90346L14.2088 12.3514C13.9315 12.7506 13.6875 13.1 13.4768 13.3994C13.2661 13.6989 13.0664 13.9484 12.8779 14.1481C12.7004 14.3477 12.5174 14.4974 12.3289 14.5972C12.1404 14.6971 11.9296 14.747 11.6967 14.747C11.5747 14.747 11.4638 14.7248 11.364 14.6804C11.2642 14.625 11.1865 14.5695 11.1311 14.5141L10.8982 14.5972C10.8649 14.8856 10.815 15.1407 10.7485 15.3625C10.6819 15.5843 10.6043 15.7673 10.5156 15.9115C10.5599 15.9448 10.632 15.9725 10.7318 15.9947C10.8206 16.0279 10.9093 16.0446 10.998 16.0446C11.2198 16.0446 11.4583 15.9891 11.7134 15.8782C11.9795 15.7673 12.2568 15.5899 12.5452 15.3459C12.8335 15.0908 13.1385 14.7636 13.4602 14.3643C13.7818 13.9651 14.109 13.4771 14.4417 12.9003L15.2402 14.8967C15.3733 15.2405 15.512 15.5178 15.6561 15.7285C15.8114 15.9392 16.0499 16.0446 16.3715 16.0446C16.5822 16.0446 16.8318 15.9503 17.1201 15.7618C17.4196 15.5732 17.7246 15.3403 18.0351 15.063C18.0129 14.9521 17.9852 14.8745 17.9519 14.8301C17.9297 14.7858 17.8798 14.7636 17.8022 14.7636C17.7024 14.7636 17.5693 14.8135 17.4029 14.9133C17.2477 15.0131 17.1035 15.063 16.9704 15.063C16.8706 15.063 16.7874 15.0242 16.7208 14.9466C16.6543 14.869 16.5822 14.7359 16.5046 14.5473L15.4232 11.8855L15.6728 11.5362C15.9057 11.2035 16.1109 10.9262 16.2883 10.7044C16.4658 10.4715 16.6321 10.2829 16.7874 10.1387C16.9538 9.99456 17.1201 9.8892 17.2865 9.82266C17.4528 9.75611 17.6414 9.72284 17.8521 9.72284C17.9741 9.72284 18.0739 9.75057 18.1516 9.80602C18.2403 9.85038 18.3124 9.90029 18.3678 9.95575L18.6174 9.87256C18.6506 9.5842 18.7005 9.34021 18.7671 9.14057C18.8336 8.94094 18.9113 8.76903 19 8.62485C18.878 8.53613 18.7283 8.49176 18.5508 8.49176C18.0961 8.49176 17.6026 8.71358 17.0702 9.15721C16.5378 9.58975 15.9112 10.3162 15.1903 11.3365L14.3585 9.24039C14.2698 9.01858 14.1644 8.84112 14.0424 8.70803C13.9315 8.56385 13.7541 8.49176 13.5101 8.49176C13.4276 8.49176 13.3324 8.49176 13.2284 8.50323C13.2287 8.50257 13.2289 8.50192 13.2292 8.50127L10.9058 8.6914L11.0057 8.0925C11.1166 7.44923 11.2164 6.92796 11.3051 6.5287C11.4049 6.11834 11.5047 5.79671 11.6046 5.5638C11.7044 5.33089 11.8097 5.17008 11.9206 5.08135C12.0316 4.99262 12.148 4.94826 12.27 4.94826C12.4585 4.94826 12.6415 5.03144 12.819 5.1978C12.9965 5.35307 13.1351 5.50835 13.2349 5.66362L13.5676 5.5638C13.612 5.30871 13.6674 5.07026 13.734 4.84844C13.8005 4.62663 13.8726 4.43809 13.9503 4.28281C13.795 4.19409 13.6231 4.12754 13.4345 4.08318C13.2571 4.02773 13.0907 4 12.9355 4C12.5695 4 12.1924 4.08318 11.8042 4.24954C11.416 4.4159 11.05 4.64326 10.7062 4.93163C10.3735 5.21998 10.0796 5.56934 9.82449 5.9797C9.58049 6.37897 9.41968 6.81151 9.34204 7.27732L9.0925 8.6914H7.46581C7.31054 8.6914 7.19963 8.76903 7.13309 8.9243C7.06655 9.06848 7.02218 9.2293 7 9.40675Z",
        className: "filled"
      })
    })
  }));
};
;// CONCATENATED MODULE: ../../packages/styleguide/src/icons/CommentIcon.tsx


function CommentIcon_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function CommentIcon_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      CommentIcon_ownKeys(Object(source), true).forEach(function (key) {
        (0,defineProperty/* default */.Z)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      CommentIcon_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}




const CommentIcon = props => {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(AbstractIcon, CommentIcon_objectSpread(CommentIcon_objectSpread({}, props), {}, {
    "data-icon": "CommentIcon",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M9 12C9.55229 12 10 11.5523 10 11C10 10.4477 9.55229 10 9 10C8.44771 10 8 10.4477 8 11C8 11.5523 8.44771 12 9 12Z",
        className: "filled"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M13 11C13 11.5523 12.5523 12 12 12C11.4477 12 11 11.5523 11 11C11 10.4477 11.4477 10 12 10C12.5523 10 13 10.4477 13 11Z",
        className: "filled"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M15 12C15.5523 12 16 11.5523 16 11C16 10.4477 15.5523 10 15 10C14.4477 10 14 10.4477 14 11C14 11.5523 14.4477 12 15 12Z",
        className: "filled"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.5 5C5.11929 5 4 6.04144 4 7.32612V13.8393C4 15.124 5.11929 16.1654 6.5 16.1654H9.84456L11.5743 18.7787C11.7695 19.0738 12.2305 19.0738 12.4257 18.7787L14.1554 16.1654H17.5C18.8807 16.1654 20 15.124 20 13.8393V7.32612C20 6.04144 18.8807 5 17.5 5H6.5ZM10.7043 14.5654H6.5C5.89236 14.5654 5.6 14.1336 5.6 13.8393V7.32612C5.6 7.03177 5.89236 6.6 6.5 6.6H17.5C18.1076 6.6 18.4 7.03177 18.4 7.32612V13.8393C18.4 14.1336 18.1076 14.5654 17.5 14.5654H13.2957L12 16.5231L10.7043 14.5654Z",
        className: "filled"
      })]
    })
  }));
};
;// CONCATENATED MODULE: ../../packages/styleguide/src/icons/EyeOpenIcon.tsx


function EyeOpenIcon_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function EyeOpenIcon_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      EyeOpenIcon_ownKeys(Object(source), true).forEach(function (key) {
        (0,defineProperty/* default */.Z)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      EyeOpenIcon_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}



const EyeOpenIcon = props => {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(AbstractIcon, EyeOpenIcon_objectSpread(EyeOpenIcon_objectSpread({}, props), {}, {
    "data-icon": "EyeOpenIcon",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.4876 8.60493C10.1172 8.65045 8.82944 9.00966 7.6906 9.61253C7.5023 10.1007 7.39874 10.632 7.39874 11.1903C7.39874 13.6127 9.36246 15.5764 11.7848 15.5764C14.2072 15.5764 16.171 13.6127 16.171 11.1903C16.171 10.7064 16.0932 10.2428 15.9498 9.81004C15.2491 9.39658 14.4859 9.07806 13.6779 8.87185C14.3493 9.42072 14.7779 10.2554 14.7779 11.1903C14.7779 12.8433 13.4379 14.1833 11.7848 14.1833C10.1318 14.1833 8.79179 12.8433 8.79179 11.1903C8.79179 10.5163 9.01452 9.89444 9.3904 9.39415V9.39444C9.3904 10.0556 9.92641 10.5917 10.5876 10.5917C11.2488 10.5917 11.7848 10.0556 11.7848 9.39444C11.7848 9.09196 11.6727 8.81568 11.4876 8.60493ZM17.2627 13.6079C17.5834 12.8823 17.7642 12.081 17.7708 11.2382C17.9407 11.412 18.1035 11.5929 18.2587 11.7804C18.4533 12.0155 18.4533 12.3504 18.2587 12.5855C17.9547 12.9528 17.6215 13.2948 17.2627 13.6079ZM5.79874 11.1903C5.79874 12.3393 6.12246 13.4127 6.68367 14.3242C5.95485 13.8436 5.30171 13.2569 4.74595 12.5855C4.55135 12.3504 4.55135 12.0155 4.74595 11.7804C5.07171 11.3869 5.43092 11.0225 5.81923 10.6914C5.80566 10.8559 5.79874 11.0223 5.79874 11.1903ZM3.51345 10.7602C2.82885 11.5872 2.82885 12.7788 3.51345 13.6058C5.41479 15.9026 8.28768 17.3659 11.5023 17.3659C14.717 17.3659 17.5899 15.9026 19.4912 13.6058C20.1758 12.7788 20.1758 11.5872 19.4912 10.7602C18.8464 9.98122 18.0898 9.29812 17.2461 8.73547C17.207 8.6486 17.1659 8.56284 17.1228 8.47824C15.5636 7.53978 13.7373 7 11.7848 7C11.7377 7 11.6906 7.00031 11.6436 7.00094C11.5966 7.00031 11.5495 7 11.5023 7C8.28768 7 5.41479 8.46332 3.51345 10.7602Z",
        className: "filled"
      })
    })
  }));
};
;// CONCATENATED MODULE: ../../packages/styleguide/src/icons/StarIcon.tsx


function StarIcon_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function StarIcon_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      StarIcon_ownKeys(Object(source), true).forEach(function (key) {
        (0,defineProperty/* default */.Z)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      StarIcon_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}



const StarIcon = props => {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(AbstractIcon, StarIcon_objectSpread(StarIcon_objectSpread({}, props), {}, {
    "data-icon": "StarIcon",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M11.7618 4.98351C11.8357 4.7513 12.1643 4.7513 12.2382 4.98351L13.8331 9.99284C13.8661 10.0966 13.9625 10.167 14.0713 10.167H19.2431C19.484 10.167 19.5855 10.4743 19.392 10.6178L15.1992 13.7266C15.1134 13.7902 15.0775 13.9014 15.1099 14.0032L16.7093 19.0268C16.783 19.258 16.5171 19.448 16.3222 19.3035L12.1489 16.2091C12.0605 16.1435 11.9395 16.1435 11.8511 16.2091L7.67778 19.3035C7.48285 19.448 7.21704 19.258 7.29066 19.0268L8.89007 14.0032C8.92249 13.9014 8.8866 13.7902 8.80075 13.7266L4.60801 10.6178C4.41447 10.4743 4.51597 10.167 4.75691 10.167H9.92869C10.0375 10.167 10.1339 10.0966 10.1669 9.99284L11.7618 4.98351Z",
        className: "filled"
      })
    })
  }));
};
;// CONCATENATED MODULE: ../../packages/styleguide/src/icons/FolderIcon.tsx


function FolderIcon_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function FolderIcon_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      FolderIcon_ownKeys(Object(source), true).forEach(function (key) {
        (0,defineProperty/* default */.Z)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      FolderIcon_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}



const FolderIcon = props => {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(AbstractIcon, FolderIcon_objectSpread(FolderIcon_objectSpread({}, props), {}, {
    "data-icon": "FolderIcon",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M5 19.2L19 19.2C20.1046 19.2 21 18.3046 21 17.2L21 9.2C21 8.09543 20.1046 7.2 19 7.2L10.8361 7.2C10.0785 7.2 9.386 6.772 9.04721 6.09443L8.95279 5.90558C8.614 5.22801 7.92147 4.8 7.16393 4.8L5 4.8C3.89543 4.8 3 5.69543 3 6.8L3 17.2C3 18.3046 3.89543 19.2 5 19.2Z",
        className: "filled"
      })
    })
  }));
};
;// CONCATENATED MODULE: ../../packages/styleguide/src/icons/ShareIcon.tsx


function ShareIcon_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function ShareIcon_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ShareIcon_ownKeys(Object(source), true).forEach(function (key) {
        (0,defineProperty/* default */.Z)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ShareIcon_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}




const ShareIcon = props => {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(AbstractIcon, ShareIcon_objectSpread(ShareIcon_objectSpread({}, props), {}, {
    "data-icon": "ShareIcon",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M7.44947 8.52884C7.09799 8.17737 7.09799 7.60752 7.44947 7.25605L10.6565 4.04902C11.3985 3.30702 12.6015 3.30702 13.3435 4.04902L16.5505 7.25605C16.902 7.60752 16.902 8.17737 16.5505 8.52884C16.1991 8.88032 15.6292 8.88032 15.2777 8.52884L12.9 6.15111L12.9 15.4575H11.1L11.1 6.15109L8.72226 8.52884C8.37079 8.88032 7.80094 8.88032 7.44947 8.52884Z",
        className: "filled"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M7.79057 9.90127C7.8347 9.89855 7.87919 9.89718 7.924 9.89718H9.39057V11.8972H7.924C7.8451 11.8972 7.78114 11.9611 7.78114 12.04V17.8788C7.78114 17.9577 7.8451 18.0217 7.924 18.0217H16.076C16.1549 18.0217 16.2188 17.9577 16.2188 17.8788V12.04C16.2188 11.9611 16.1549 11.8972 16.076 11.8972H14.6094V9.89718H16.076C16.1208 9.89718 16.1653 9.89855 16.2094 9.90127C17.3307 9.97016 18.2188 10.9014 18.2188 12.04V17.8788C18.2188 19.0623 17.2595 20.0217 16.076 20.0217H7.924C6.74053 20.0217 5.78114 19.0623 5.78114 17.8788V12.04C5.78114 10.9014 6.66926 9.97015 7.79057 9.90127Z",
        className: "filled"
      })]
    })
  }));
};
;// CONCATENATED MODULE: ../../packages/styleguide/src/icons/UsersOnIcon.tsx


function UsersOnIcon_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function UsersOnIcon_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      UsersOnIcon_ownKeys(Object(source), true).forEach(function (key) {
        (0,defineProperty/* default */.Z)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      UsersOnIcon_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}




const UsersOnIcon = props => {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(AbstractIcon, UsersOnIcon_objectSpread(UsersOnIcon_objectSpread({}, props), {}, {
    "data-icon": "UsersOnIcon",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M6.06739 19H13.985C14.5991 19 15.0201 18.3811 14.7945 17.8099L13.0802 13.4687C12.8178 12.804 12.1757 12.3673 11.4611 12.3673H8.59122C7.8766 12.3673 7.23458 12.804 6.97212 13.4687L5.25784 17.8099C5.03229 18.3811 5.45327 19 6.06739 19Z",
        className: "filled"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M13.5077 8.48152C13.5077 10.4043 11.949 11.963 10.0262 11.963C8.10339 11.963 6.54466 10.4043 6.54466 8.48152C6.54466 6.55873 8.10339 5 10.0262 5C11.949 5 13.5077 6.55873 13.5077 8.48152Z",
        className: "filled"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M15.6648 8.52715C15.6648 10.4751 14.0856 12.0543 12.1377 12.0543C12.0309 12.0543 11.9253 12.0496 11.8211 12.0403C13.4064 11.6947 14.5935 10.283 14.5935 8.59406C14.5935 6.75277 13.1826 5.24102 11.383 5.08092C11.6261 5.02792 11.8786 5 12.1377 5C14.0856 5 15.6648 6.57916 15.6648 8.52715Z",
        className: "filled"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M15.6388 17.2584C15.9272 17.9888 15.52 18.7705 14.8277 19H15.4799C16.4131 19 17.0529 18.0595 16.7101 17.1915L15.2628 13.5264C14.9526 12.7408 14.1938 12.2246 13.3491 12.2246H11.2065C11.3851 12.2246 11.5599 12.2477 11.7274 12.2915H12.2778C13.1225 12.2915 13.8813 12.8077 14.1915 13.5933L15.6388 17.2584Z",
        className: "filled"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M17.6648 8.52715C17.6648 10.4751 16.0856 12.0543 14.1377 12.0543C14.0309 12.0543 13.9253 12.0496 13.8211 12.0403C15.4064 11.6947 16.5935 10.283 16.5935 8.59406C16.5935 6.75277 15.1826 5.24102 13.383 5.08092C13.6261 5.02792 13.8786 5 14.1377 5C16.0856 5 17.6648 6.57916 17.6648 8.52715Z",
        className: "filled"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M17.6388 17.2584C17.9272 17.9888 17.52 18.7705 16.8277 19H17.4799C18.4131 19 19.0529 18.0595 18.7101 17.1915L17.2628 13.5264C16.9526 12.7408 16.1938 12.2246 15.3491 12.2246H13.2065C13.3851 12.2246 13.5599 12.2477 13.7274 12.2915H14.2778C15.1225 12.2915 15.8813 12.8077 16.1915 13.5933L17.6388 17.2584Z",
        className: "filled"
      })]
    })
  }));
};
;// CONCATENATED MODULE: ./app/components/Landing/sections/LandingFeatures.tsx






const StyledLandingFeature = /*#__PURE__*/(0,styled/* default */.Z)("article")({
  name: "StyledLandingFeature",
  class: "suj3xvr"
});
const LandingFeatures = () => {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(LandingSection_StyledLandingSection, {
    className: "features dotted ",
    bg: 'var(--clr-nav-shadow)',
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "content",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "headline",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
          children: "Stop Juggling Between Slow Apps"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          children: "Everything you need to refine your team's workflow and publish content faster in one place."
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledLandingFeature, {
        id: "featureUI",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "featureCol copy",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "copyContent",
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("h2", {
              children: ["Pro Features,", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), " Made Easy."]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              children: "Easy to learn with a forgiving interface. Advanced features, plugins, & tools are hidden away until you need them."
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "icon",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(HistoryIcon, {
                    size: "2.5rem",
                    color: "var(--clr-text)"
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: "featureLi",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
                    children: "Multi-Paradigm Editing"
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                    children: "Edit via timeline, transcript, outline, or cards. Switch anytime, keep your changes. No restarting from scratch if you make a mistake."
                  })]
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "icon",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(EffectsIcon, {
                    size: "2.5rem",
                    color: "var(--clr-text)"
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: "featureLi",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
                    children: "Professional Effects"
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                    children: "Desktop-grade effects at your fingertips for color correction, parametric equalizers, & more."
                  })]
                })]
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "ctaLearnMore buttonWrap",
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Button, {
                as: "a",
                href: "/features/ui",
                className: "secondary",
                children: ["Learn more ", '->']
              })
            })]
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "featureCol figure",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "figure-container",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "img-container",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(next_image["default"], {
                src: "/img/vidbase-screenshot.png",
                alt: "A place for everything and everything in its place. ",
                width: "1024",
                height: "576",
                priority: true
              })
            })
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledLandingFeature, {
        id: "featureCollab",
        className: "left",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "featureCol copy",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "copyContent",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
              children: "Content Editing, Simplified."
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              children: "Powerful new editing tools allow creators to skip the boring busywork & focus on being creative."
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "icon",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(CommentIcon, {
                    size: "2.5rem",
                    color: "var(--clr-text)"
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: "featureLi",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
                    children: "Usable Transcripts, For Once"
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                    children: "Best-in-class speech-to-text processing learns & adapts to you over time. Tags people, places, objects, colors, & more."
                  })]
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "icon",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(EyeOpenIcon, {
                    size: "2.5rem",
                    color: "var(--clr-text)"
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: "featureLi",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
                    children: "Instantly Find that Perfect Clip"
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                    children: "Vidbase automatically tags, organizes, and indexes your media for incredibly fast & flexible search. Customize it to fit your needs."
                  })]
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "icon",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(StarIcon, {
                    size: "2.5rem",
                    color: "var(--clr-text)",
                    className: "filled"
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: "featureLi",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
                    children: "A Magical Experience"
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                    children: "Remove people, objects, and backgrounds with a touch. Remix 20 of your best takes into the perfect one. So much more."
                  })]
                })]
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "ctaLearnMore buttonWrap",
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Button, {
                as: "a",
                href: "/features/ml",
                className: "secondary",
                children: ["Learn more ", '->']
              })
            })]
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "featureCol figure",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "figure-container",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "img-container",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(next_image["default"], {
                src: "/img/vidbase-screenshot.png",
                alt: "A place for everything and everything in its place. ",
                width: "1024",
                height: "576",
                priority: true
              })
            })
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledLandingFeature, {
        id: "featureCollab",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "featureCol copy",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "copyContent",
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("h2", {
              children: ["Collaborate", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "in Real-Time."]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              children: "Work together to explore ideas, share revisions, and review feedback. Iterate rapidly and publish the best content."
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "icon",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(FolderIcon, {
                    size: "2.5rem",
                    color: "var(--clr-text)"
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: "featureLi",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
                    children: "Work Together Seamlessly"
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                    children: "Your whole team can work on the same file at the same time. No more sharing files like 'wip_3020_rev1_edit2_final_FINAL'."
                  })]
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "icon",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(ShareIcon, {
                    size: "2.5rem",
                    color: "var(--clr-text)"
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: "featureLi",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
                    children: "Share with Ease"
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                    children: "Collect feedback & edits on your draft with just a link. Or show off your timelines."
                  })]
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "icon",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(UsersOnIcon, {
                    size: "2.5rem",
                    color: "var(--clr-text)"
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: "featureLi",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
                    children: "Modernized Workflows"
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                    children: "Sharing, comments, approvals, proxy files, asset libraries, branches, snapshots, shared export settings, and more."
                  })]
                })]
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "ctaLearnMore buttonWrap",
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Button, {
                as: "a",
                href: "/features/collab",
                className: "secondary",
                children: ["Learn more ", '->']
              })
            })]
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "featureCol figure",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "figure-container",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "img-container",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(next_image["default"], {
                src: "/img/vidbase-screenshot.png",
                alt: "A place for everything and everything in its place. ",
                width: "1024",
                height: "576",
                priority: true
              })
            })
          })
        })]
      })]
    })
  });
};

__webpack_require__(6743);
;// CONCATENATED MODULE: ./app/components/Landing/sections/LandingLogoCloud.tsx




const StyledLogoCloud = /*#__PURE__*/(0,styled/* default */.Z)("div")({
  name: "StyledLogoCloud",
  class: "s18upexp"
});
const LandingLogoCloud = () => {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(LandingSection_StyledLandingSection, {
    className: "logosCloud",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "content",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
        className: "blue",
        children: "Trusted By Top Companies & Creators"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledLogoCloud, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "logoFig",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
              src: "/img/vidbase-studios-logo.svg",
              alt: "vidbase.studio",
              width: "312",
              height: "130"
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "logoFig",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
              src: "/img/vidbase-studios-logo.svg",
              alt: "vidbase.studio",
              width: "312",
              height: "130"
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "logoFig",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
              src: "/img/vidbase-studios-logo.svg",
              alt: "vidbase.studio",
              width: "312",
              height: "130"
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "logoFig",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
              src: "/img/vidbase-studios-logo.svg",
              alt: "vidbase.studio",
              width: "312",
              height: "130"
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "logoFig",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
              src: "/img/vidbase-studios-logo.svg",
              alt: "vidbase.studio",
              width: "312",
              height: "130"
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "logoFig",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
              src: "/img/vidbase-studios-logo.svg",
              alt: "vidbase.studio",
              width: "312",
              height: "130"
            })
          })
        })]
      })]
    })
  });
};

__webpack_require__(1977);
;// CONCATENATED MODULE: ./app/components/Landing/sections/LandingIntegrations.tsx




const LandingIntegrations = () => {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(LandingSection_StyledLandingSection, {
    className: "integrations",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "content",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "headline",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
          children: "Integrations"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          children: "Plays well with others. Integrate as much or as little as you want."
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledLogoCloud, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "logoFig",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
              src: "/img/vidbase-studios-logo.svg",
              alt: "vidbase.studio",
              width: "312",
              height: "130"
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "logoFig",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
              src: "/img/vidbase-studios-logo.svg",
              alt: "vidbase.studio",
              width: "312",
              height: "130"
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "logoFig",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
              src: "/img/vidbase-studios-logo.svg",
              alt: "vidbase.studio",
              width: "312",
              height: "130"
            })
          })
        })]
      })]
    })
  });
};
;// CONCATENATED MODULE: ./app/components/Landing/sections/LandingNotImplementedYet.tsx



const LandingNotImplementedYet = () => {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(LandingSection_StyledLandingSection, {
    className: "productions ",
    bg: 'var(--clr-nav-shadow)',
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "content",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "headline",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
          children: "Coming Soon"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          children: "Sorry, we're still finishing this page up. Check back again soon."
        })]
      })
    })
  });
};
// EXTERNAL MODULE: ../../node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(8879);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ../../node_modules/dayjs/plugin/localizedFormat.js
var localizedFormat = __webpack_require__(3147);
var localizedFormat_default = /*#__PURE__*/__webpack_require__.n(localizedFormat);
// EXTERNAL MODULE: ../../node_modules/@radix-ui/react-avatar/dist/index.module.js + 4 modules
var index_module = __webpack_require__(854);
;// CONCATENATED MODULE: ../../packages/styleguide/src/components/Avatar.tsx


const Avatar_excluded = ["src", "alt", "initials", "variant", "cors", "delayMs"];

function Avatar_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function Avatar_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      Avatar_ownKeys(Object(source), true).forEach(function (key) {
        (0,defineProperty/* default */.Z)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      Avatar_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}






const BorderRadii = {
  round: '100%',
  rounded: '25%',
  square: '0%'
};
const StyledAvatar = /*#__PURE__*/(0,styled/* default */.Z)(index_module/* Root */.fC)({
  name: "StyledAvatar",
  class: "s1det9gv",
  vars: {
    "s1det9gv-0": [props => props.size || '2.24rem'],
    "s1det9gv-2": [props => props.margin || '0'],
    "s1det9gv-3": [props => BorderRadii[props.variant || 'round'] || '100%']
  }
});
const StyledAvatarImage = /*#__PURE__*/(0,styled/* default */.Z)("div")({
  name: "StyledAvatarImage",
  class: "sxetcyi"
});
const StyledFallback = /*#__PURE__*/(0,styled/* default */.Z)(index_module/* Fallback */.NY)({
  name: "StyledFallback",
  class: "s1bl9p93"
});
const Avatar = _ref => {
  let {
    src,
    alt,
    initials = '',
    variant = 'round',
    cors = false,
    delayMs = 600
  } = _ref,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, Avatar_excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledAvatar, Avatar_objectSpread(Avatar_objectSpread({}, props), {}, {
    variant: variant,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StyledFallback, {
      children: initials.slice(0, 2)
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledAvatarImage, {
      children: cors === true ? /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
        src: src,
        alt: alt,
        width: "64",
        height: "64"
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(next_image["default"], {
        src: src,
        alt: alt,
        width: "64",
        height: "64"
      })
    })]
  }));
};

__webpack_require__(1010);
;// CONCATENATED MODULE: ./app/components/Landing/sections/LandingProductions.tsx




dayjs_min_default().extend((localizedFormat_default()));




const StyledMediaCard = /*#__PURE__*/(0,styled/* default */.Z)("div")({
  name: "StyledMediaCard",
  class: "smv5a35"
});
const PRODUCTION_LINKS = {
  'Vidbase Creators': 'https://vid.bs/creators/yt',
  'Fund BMC': 'https://vid.bs/fundbmc/yt'
};
const PRODUCTIONS_RELEASES = [{
  type: 'Video Essay',
  href: '#',
  slug: 'succession-tig',
  account: 'Vidbase Creators',
  creator: 'Nancy Xu',
  date: '2022-03-01T17:00:00.000Z',
  avatar: 'https://cdn.vidbase.app/img/vidbase-creators-avatar.png',
  thumbnail: 'https://cdn.vidbase.app/episodes/succession-the-impossible-game-thumbnail.png',
  headline: 'Succession - The Impossible Game',
  body: "This video essay dissects the game of Succession: is it really possible for Roman,\n\t\tShiv, or Kendall to win? The ending of season three shows that the race to become\n\t\tthe next CEO is in fact a scheme through which Logan Roy controls and wields power\n\t\tover his children \u2014 one designed so that only he can win, again, and again. In\n\t\tthis video, we dive deeper into why that is, and also explore the show's subtext\n\t\tsurrounding the cyclical nature of abuse."
}, {
  type: 'Interview',
  slug: 'fundbmc-s2e3',
  href: 'https://youtu.be/jVeckkjE2K0',
  account: 'Fund BMC',
  creator: 'Hong Quan',
  date: '2020-05-20T17:00:00.000Z',
  avatar: 'https://cdn.vidbase.app/img/fundbmc-avatar.png',
  thumbnail: 'https://fundbmc.com/episodes/episode-010-thumbnail.jpg',
  headline: 'Fund BMC S02E03: Jonathan Basker',
  body: "Hong (@quan) and Jonathan (@basker) have a chat about finding a job during downturns and how to prepare yourself for the best outcome. Topics include: job hunting during COVID-19 (2:00), Hong's first job, how to get into tech/startups without a technical background, how to know if your resume isn't working, what a day in the life of a startup recruiter looks like, the best tool to help you look credible, an important tactical way to stand out with your resume, and why (if you can) skip the resume entirely."
}, {
  type: 'Interview',
  slug: 'fundbmc-s2e2',
  href: 'https://www.youtube.com/watch?v=pXY0ae27_ts',
  account: 'Fund BMC',
  creator: 'Hong Quan',
  date: '2020-05-05T17:00:00.000Z',
  avatar: 'https://cdn.vidbase.app/img/fundbmc-avatar.png',
  thumbnail: 'https://fundbmc.com/episodes/episode-009-thumbnail.jpg',
  headline: 'Fund BMC S02E02: Arlan Hamilton',
  body: "Hong (@quan) and Arlan (@arlanwashere) have a chat about the wild ride of investing in underrepresented groups. Topics include: how to invest in the underrepresented, how venture capital works, her first million podcast, almost being on reality TV, whether Asian Americans are considered underrepresented, and her new book \"It's About Damn Time\"."
}];
const LandingProductions = () => {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(LandingSection_StyledLandingSection, {
    className: "productions dotted",
    bg: 'var(--clr-nav-shadow)',
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "content",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "headline",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
          children: "Productions"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          children: "From tutorials to original content, enjoy the show!"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledMediaCard, {
        className: "media-cards",
        children: PRODUCTIONS_RELEASES.map((episode, i) => {
          return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "media-card-container",
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "media-card",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                href: episode.href,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(next_image["default"], {
                  src: episode.thumbnail,
                  alt: "".concat(episode.headline, " | ").concat(episode.account),
                  width: "312",
                  height: "175.5"
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "card-body",
                id: episode.slug,
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
                  children: episode.type
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  href: episode.href,
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
                    children: episode.headline
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("input", {
                  type: "checkbox",
                  id: "".concat(episode.slug, "-expanded")
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                  className: "clamped",
                  children: episode.body
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextLink, {
                  as: "label",
                  className: "more",
                  htmlFor: "".concat(episode.slug, "-expanded"),
                  role: "button",
                  children: "Show more."
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextLink, {
                  as: "label",
                  className: "less",
                  htmlFor: "".concat(episode.slug, "-expanded"),
                  role: "button",
                  children: "Show less."
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "media-creator",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  href: PRODUCTION_LINKS[episode.account] || '',
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(Avatar, {
                    src: episode.avatar,
                    alt: episode.account,
                    initials: 'VB'
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: "media-creator-meta",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                    href: PRODUCTION_LINKS[episode.account] || '',
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
                      children: episode.account
                    })
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
                    children: [dayjs_min_default()(episode.date).format('ll'), " \xB7 ", episode.creator]
                  })]
                })]
              })]
            })
          }, "episode-".concat(i));
        })
      })]
    })
  });
};

__webpack_require__(6680);
;// CONCATENATED MODULE: ./app/components/Landing/sections/LandingScreenshot.tsx



const StyledLandingScreenshotFigure = /*#__PURE__*/(0,styled/* default */.Z)("div")({
  name: "StyledLandingScreenshotFigure",
  class: "s1vhebo9"
});
const LandingScreenshot = () => {
  return /*#__PURE__*/_jsx(StyledLandingSection, {
    className: "screenshot",
    children: /*#__PURE__*/_jsx("div", {
      className: "content",
      children: /*#__PURE__*/_jsx(StyledLandingScreenshotFigure, {
        className: "screenshot-img",
        children: /*#__PURE__*/_jsx("img", {
          src: "/img/1024x576.svg",
          alt: "placeholder"
        })
      })
    })
  });
};

__webpack_require__(524);
;// CONCATENATED MODULE: ./app/components/Landing/sections/LandingSignup.tsx




const StyledNewsletter = /*#__PURE__*/(0,styled/* default */.Z)("div")({
  name: "StyledNewsletter",
  class: "s1wh0uhe"
});
const LandingSignup = () => {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(LandingSection_StyledLandingSection, {
    id: "newsletter",
    className: "signup-cta",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "content",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "headline",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
          children: "Want News & Updates?"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          children: "Sign up for our newsletter."
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledNewsletter, {
        className: "newsletter-form",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("iframe", {
          title: "Signup for our newsletter (Substack)",
          src: "https://justfixitinpost.substack.com/embed",
          width: "480",
          height: "280",
          style: {
            background: 'var(--clr-text-bright)'
          },
          frameBorder: "0",
          scrolling: "no"
        })
      })]
    })
  });
};

__webpack_require__(6324);
;// CONCATENATED MODULE: ./app/components/Landing/sections/index.ts










;// CONCATENATED MODULE: ./app/components/Landing/index.ts





;// CONCATENATED MODULE: ./app/components/index.ts


/***/ }),

/***/ 1010:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 8519:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 1384:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 329:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 3585:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 3312:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 3981:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 9639:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 2557:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 8024:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 961:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 110:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 6743:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 1977:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 6680:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 524:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 9875:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 6324:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 4011:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ })

}]);